<template>
  <ul
    class="navbar-nav bg-gradient-light sidebar sidebar-light accordion"
    id="accordionSidebar"
  >
    <!-- Sidebar - Brand -->
    <router-link
      :to="{ name: 'dashboard' }"
      class="sidebar-brand d-flex align-items-center justify-content-center"
    >
      <img
        class="sidebar-brand-icon"
        src="@/assets/logo-px.png"
        width="21px"
        height="145%"
      />

      <div class="sidebar-brand-text text-primary mx-3 mt-1">
        <font face="Netto" size="5">paxel</font>
      </div>
    </router-link>

    <!-- Divider -->
    <hr class="sidebar-divider my-0" />

    <!-- Nav Item - Dashboard -->
    <li
      class="nav-item"
      @mouseover="dashboard = true"
      @mouseleave="dashboard = false"
      :class="{ 'active border-right-active': routename === 'dashboard' }"
    >
      <router-link :to="{ name: 'dashboard' }" class="nav-link">
        <img
          src="@/assets/ic-dashboard.svg"
          alt
          class="px-2"
          v-if="dashboard || routename === 'dashboard'"
        />
        <img
          src="@/assets/ic-dashboard-unselect.svg"
          alt
          class="px-2"
          v-else-if="routename != 'dashboard' && !dashboard"
        />
        <span>Dashboard</span>
      </router-link>
    </li>

    <!-- Divider -->
    <div>
      <hr class="sidebar-divider" />

      <div class="sidebar-heading">
        {{ session.role == "superadmin" ? "Super Admin" : "Admin" }}
      </div>
      <li
        @mouseover="internal_user = true"
        @mouseleave="internal_user = false"
        class="nav-item"
        :class="{
          'active border-right-active':
            routename === 'InternalUser' ||
            routename === 'addInternalUser' ||
            routename === 'editInternalUser',
        }"
      >
        <router-link :to="{ name: 'InternalUser' }" class="nav-link">
          <img
            src="@/assets/ic-manage-account_color.svg"
            alt
            class="px-2"
            v-if="
              internal_user ||
              routename === 'InternalUser' ||
              routename === 'addInternalUser' ||
              routename === 'editInternalUser'
            "
          />
          <img
            src="@/assets/ic-manage-account_bw.svg"
            alt
            class="px-2"
            v-else-if="
              routename != 'InternalUser' &&
              routename != 'addInternalUser' &&
              routename != 'editInternalUser' &&
              !internal_user
            "
          />
          <span>Internal User</span>
        </router-link>
      </li>
    </div>
    <div v-show="session.role == 'superadmin'">
      <hr class="sidebar-divider" />

      <div class="sidebar-heading">
        Messaging Service
      </div>
      <li
        @mouseover="message_service = true"
        @mouseleave="message_service = false"
        class="nav-item"
        :class="{
          'active border-right-active':
            routename === 'MessageLog',
        }"
      >
        <router-link :to="{ name: 'MessageLog' }" class="nav-link">
          <img
            src="@/assets/ic-manage-account_color.svg"
            alt
            class="px-2"
            v-if="
              message_service ||
              routename === 'MessageLog'
            "
          />
          <img
            src="@/assets/ic-manage-account_bw.svg"
            alt
            class="px-2"
            v-else-if="
              routename != 'MessageLog' &&
              !message_service
            "
          />
          <span>Message Log</span>
        </router-link>
      </li>
      <li
        @mouseover="message_settings = true"
        @mouseleave="message_settings = false"
        class="nav-item"
        :class="{
          'active border-right-active':
            routename === 'MessageSettings',
        }"
      >
        <router-link :to="{ name: 'MessageSettings' }" class="nav-link">
          <img
            src="@/assets/ic-manage-account_color.svg"
            alt
            class="px-2"
            v-if="
              message_settings ||
              routename === 'MessageSettings'
            "
          />
          <img
            src="@/assets/ic-manage-account_bw.svg"
            alt
            class="px-2"
            v-else-if="
              routename != 'MessageSettings' &&
              !message_settings
            "
          />
          <span>Message Settings</span>
        </router-link>
      </li>
    </div>
    <div v-show="session.role == 'superadmin'">
      <hr class="sidebar-divider" />

      <div class="sidebar-heading">
        Shortener Service
      </div>
      <li
        @mouseover="shortener_service = true"
        @mouseleave="shortener_service = false"
        class="nav-item"
        :class="{
          'active border-right-active':
            routename === 'ShortenerURL',
        }"
      >
        <router-link :to="{ name: 'ShortenerURL' }" class="nav-link">
          <img
            src="@/assets/ic-manage-account_color.svg"
            alt
            class="px-2"
            v-if="
              shortener_service ||
              routename === 'ShortenerURL'
            "
          />
          <img
            src="@/assets/ic-manage-account_bw.svg"
            alt
            class="px-2"
            v-else-if="
              routename != 'ShortenerURL' &&
              !shortener_service
            "
          />
          <span>Shortener URLs</span>
        </router-link>
      </li>
    </div>
    <!-- Heading -->

    <div
      v-show="
        session.role == 'ce' ||
        session.role == 'superadmin' ||
        session.role == 'operation' ||
        session.role == 'finance' ||
        session.role == 'mentor' ||
        session.role == 'customer_success' ||
        session.role == 'claim' ||
        session.role == 'claim_manager'
      "
    >
      <hr class="sidebar-divider" />
      <div class="sidebar-heading">CE</div>
      <li
        @mouseover="cx = true"
        @mouseleave="cx = false"
        class="nav-item"
        :class="{
          'active border-right-active':
            routename === 'cxReport' ||
            routename === 'cxDetailComplaint' ||
            routename === 'cxDetailClaim' ||
            routename === 'cxDetailFeedback' ||
            routename === 'cxDetailInformation',
        }"
      >
        <router-link :to="{ name: 'cxReport' }" class="nav-link">
          <img
            src="@/assets/ic-manage-account_color.svg"
            alt
            class="px-2"
            v-if="
              cx ||
              routename === 'cxReport' ||
              routename === 'cxDetailComplaint' ||
              routename === 'cxDetailClaim' ||
              routename === 'cxDetailFeedback' ||
              routename === 'cxDetailInformation'
            "
          />
          <img
            src="@/assets/ic-manage-account_bw.svg"
            alt
            class="px-2"
            v-else-if="
              routename != 'cxReport' &&
              routename != 'cxDetailComplaint' &&
              routename != 'cxDetailClaim' &&
              routename != 'cxDetailFeedback' &&
              routename != 'cxDetailInformation' &&
              !cx
            "
          />
          <span>Customer Empathy</span>
        </router-link>
      </li>
      <li
        @mouseover="cxAutoClaim = true"
        @mouseleave="cxAutoClaim = false"
        class="nav-item"
        :class="{
          'active border-right-active':
            routename === 'cxAutoClaim' ||
            routename === 'cxDetailComplaintAutoClaim' ||
            routename === 'cxDetailAutoClaim' ||
            routename === 'cxDetailFeedbackAutoClaim' ||
            routename === 'cxDetailInformationAutoClaim',
        }"
      >
        <router-link :to="{ name: 'cxAutoClaim' }" class="nav-link">
          <img
            src="@/assets/ic-manage-account_color.svg"
            alt
            class="px-2"
            v-if="
              cxAutoClaim ||
              routename === 'cxAutoClaim' ||
              routename === 'cxDetailComplaintAutoClaim' ||
              routename === 'cxDetailAutoClaim' ||
              routename === 'cxDetailFeedbackAutoClaim' ||
              routename === 'cxDetailInformationAutoClaim'
            "
          />
          <img
            src="@/assets/ic-manage-account_bw.svg"
            alt
            class="px-2"
            v-else-if="
              routename != 'cxAutoClaim' &&
              routename != 'cxDetailComplaintAutoClaim' &&
              routename != 'cxDetailAutoClaim' &&
              routename != 'cxDetailFeedbackAutoClaim' &&
              routename != 'cxDetailInformationAutoClaim' &&
              !cxAutoClaim
            "
          />
          <span>Auto Klaim</span>
        </router-link>
      </li>
      <li
        @mouseover="cxInstantClaim = true"
        @mouseleave="cxInstantClaim = false"
        class="nav-item"
        :class="{
          'active border-right-active':
            routename === 'cxInstantClaim' ||
            routename === 'cxDetailComplaintInstantClaim' ||
            routename === 'cxDetailInstantClaim' ||
            routename === 'cxDetailFeedbackInstantClaim' ||
            routename === 'cxDetailInformationInstantClaim',
        }"
      >
        <router-link :to="{ name: 'cxInstantClaim' }" class="nav-link">
          <img
            src="@/assets/ic-manage-account_color.svg"
            alt
            class="px-2"
            v-if="
              cxInstantClaim ||
              routename === 'cxInstantClaim' ||
              routename === 'cxDetailComplaintInstantClaim' ||
              routename === 'cxDetailInstantClaim' ||
              routename === 'cxDetailFeedbackInstantClaim' ||
              routename === 'cxDetailInformationInstantClaim'
            "
          />
          <img
            src="@/assets/ic-manage-account_bw.svg"
            alt
            class="px-2"
            v-else-if="
              routename != 'cxInstantClaim' &&
              routename != 'cxDetailComplaintInstantClaim' &&
              routename != 'cxDetailInstantClaim' &&
              routename != 'cxDetailFeedbackInstantClaim' &&
              routename != 'cxDetailInformationInstantClaim' &&
              !cxInstantClaim
            "
          />
          <span>Instant Service</span>
        </router-link>
      </li>
      <!-- <li
        @mouseover="cxFoodClaim = true"
        @mouseleave="cxFoodClaim = false"
        class="nav-item"
        :class="{
          'active border-right-active':
            routename === 'cxFoodClaim' ||
            routename === 'cxDetailComplaintFoodClaim' ||
            routename === 'cxDetailFoodClaim' ||
            routename === 'cxDetailFeedbackFoodClaim' ||
            routename === 'cxDetailInformationFoodClaim',
        }"
      >
        <router-link :to="{ name: 'cxFoodClaim' }" class="nav-link">
          <img
            src="@/assets/ic-manage-account_color.svg"
            alt
            class="px-2"
            v-if="
              cxFoodClaim ||
              routename === 'cxFoodClaim' ||
              routename === 'cxDetailComplaintFoodClaim' ||
              routename === 'cxDetailFoodClaim' ||
              routename === 'cxDetailFeedbackFoodClaim' ||
              routename === 'cxDetailInformationFoodClaim'
            "
          />
          <img
            src="@/assets/ic-manage-account_bw.svg"
            alt
            class="px-2"
            v-else-if="
              routename != 'cxFoodClaim' &&
              routename != 'cxDetailComplaintFoodClaim' &&
              routename != 'cxDetailFoodClaim' &&
              routename != 'cxDetailFeedbackFoodClaim' &&
              routename != 'cxDetailInformationFoodClaim' &&
              !cxFoodClaim
            "
          />
          <span>Food Service</span>
        </router-link>
      </li> -->
      <li
        @mouseover="cxCorporateClaim = true"
        @mouseleave="cxCorporateClaim = false"
        class="nav-item"
        :class="{
          'active border-right-active':
            routename === 'cxCorporateClaim' ||
            routename === 'cxDetailComplaintCorporateClaim' ||
            routename === 'cxDetailCorporateClaim' ||
            routename === 'cxDetailFeedbackCorporateClaim' ||
            routename === 'cxDetailInformationCorporateClaim',
        }"
      >
        <router-link :to="{ name: 'cxCorporateClaim' }" class="nav-link">
          <img
            src="@/assets/ic-manage-account_color.svg"
            alt
            class="px-2"
            v-if="
              cxCorporateClaim ||
              routename === 'cxCorporateClaim' ||
              routename === 'cxDetailComplaintCorporateClaim' ||
              routename === 'cxDetailCorporateClaim' ||
              routename === 'cxDetailFeedbackCorporateClaim' ||
              routename === 'cxDetailInformationCorporateClaim'
            "
          />
          <img
            src="@/assets/ic-manage-account_bw.svg"
            alt
            class="px-2"
            v-else-if="
              routename != 'cxCorporateClaim' &&
              routename != 'cxDetailComplaintCorporateClaim' &&
              routename != 'cxDetailCorporateClaim' &&
              routename != 'cxDetailFeedbackCorporateClaim' &&
              routename != 'cxDetailInformationCorporateClaim' &&
              !cxCorporateClaim
            "
          />
          <span>Corporate</span>
        </router-link>
      </li>
      <li
        v-show="
          session.role == 'superadmin' ||
          session.role == 'claim_manager'
        "
        class="nav-item"
        @mouseover="claim_setting = true"
        @mouseleave="claim_setting = false"
        :class="{
          'active border-right-active-dropdown':
            routename === 'claimSettingPINSetting' ||
            routename === 'claimSettingPaymentLimitation',
        }"
      >
        <a
          class="nav-link collapsed"
          href="#"
          data-toggle="collapse"
          data-target="#collapseClaimSetting"
          aria-expanded="true"
          aria-controls="collapseClaimSetting"
        >
          <img
            src="@/assets/ic-manage-account_color.svg"
            alt
            class="px-2"
            v-if="
              claim_setting ||
              routename === 'claimSettingPINSetting' ||
              routename === 'claimSettingPaymentLimitation'
            "
          />
          <img
            src="@/assets/ic-manage-account_bw.svg"
            alt
            class="px-2"
            v-else-if="
              routename != 'claimSettingPINSetting' &&
              routename != 'claimSettingPaymentLimitation' &&
              !claim_setting
            "
          />
          <span>Claim Setting</span>
        </a>
        <div
          id="collapseClaimSetting"
          class="collapse"
          aria-labelledby="headingPages"
          data-parent="#accordionSidebar"
          :class="{
            show:
              routename === 'claimSettingPINSetting' ||
              routename === 'claimSettingPaymentLimitation' ||
              routename === 'claimSettingDisbursementTime'
          }"
        >
          <div class="bg-white collapse-inner text-left">
            <router-link
              :to="{ name: 'claimSettingPINSetting' }"
              :class="{
                'active border-right-active':
                  routename === 'claimSettingPINSetting'
              }"
              class="collapse-item"
              >PIN Setting</router-link
            >
            <router-link
              :to="{ name: 'claimSettingPaymentLimitation' }"
              :class="{
                'active border-right-active':
                  routename === 'claimSettingPaymentLimitation'
              }"
              class="collapse-item"
              >Payment Limitation</router-link
            >
            <router-link
              :to="{ name: 'claimSettingDisbursementTime' }"
              :class="{
                'active border-right-active':
                  routename === 'claimSettingDisbursementTime'
              }"
              class="collapse-item"
              >Disbursement Time</router-link
            >
          </div>
        </div>
      </li>
      <li
        v-show="
          session.role == 'superadmin' ||
          session.role == 'claim_manager'
        "
        @mouseover="claim_excess = true"
        @mouseleave="claim_excess = false"
        class="nav-item"
        :class="{
          'active border-right-active':
            routename === 'claimExcess',
        }"
      >
        <router-link :to="{ name: 'claimExcess' }" class="nav-link">
          <img
            src="@/assets/ic-manage-account_color.svg"
            alt
            class="px-2"
            v-if="
              claim_excess ||
              routename === 'claimExcess'
            "
          />
          <img
            src="@/assets/ic-manage-account_bw.svg"
            alt
            class="px-2"
            v-else-if="
              routename != 'claimExcess' &&
              !claim_excess
            "
          />
          <span>Excess Auto Claim</span>
        </router-link>
      </li>
    </div>
    <!-- Divider -->

    <div
      v-show="
        session.role == 'finance' ||
        session.role == 'ce' ||
        session.role == 'refund' ||
        session.role == 'superadmin'
      "
    >
      <hr class="sidebar-divider" />
      <div class="sidebar-heading">Finance</div>
      <!-- <li
        class="nav-item"
        @mouseover="dashboard_finance = true"
        @mouseleave="dashboard_finance = false"
        :class="{'active border-right-active': routename === 'DashboardFinance' || routename === 'detailTransaction'}"
      >
        <router-link :to="{name: 'DashboardFinance'}" class="nav-link">
          <img
            src="@/assets/ic-dashboard.svg"
            alt
            class="px-2"
            v-if="dashboard_finance || routename ==='DashboardFinance'|| routename === 'detailTransaction'"
          />
          <img
            src="@/assets/ic-dashboard-unselect.svg"
            alt
            class="px-2"
            v-else-if="routename != 'DashboardFinance' && !dashboard_finance && routename != 'detailTransaction'"
          />
          <span>Dashboard Finance</span>
        </router-link>
      </li>-->
      <li
        @mouseover="transaction_log = true"
        @mouseleave="transaction_log = false"
        class="nav-item"
        :class="{
          'active border-right-active':
            routename === 'TransactionLog' ||
            routename === 'detailTransactionLog',
        }"
      >
        <router-link :to="{ name: 'TransactionLog' }" class="nav-link">
          <img
            src="@/assets/ic-manage-account_color.svg"
            alt
            class="px-2"
            v-if="
              transaction_log ||
              routename === 'TransactionLog' ||
              routename === 'detailTransactionLog'
            "
          />
          <img
            src="@/assets/ic-manage-account_bw.svg"
            alt
            class="px-2"
            v-else-if="
              routename != 'TransactionLog' &&
              routename != 'detailTransactionLog' &&
              !transaction_log
            "
          />
          <span>Transaction Log</span>
        </router-link>
      </li>
      <li
        @mouseover="payment_instruction = true"
        @mouseleave="payment_instruction = false"
        class="nav-item"
        :class="{
          'active border-right-active':
            routename === 'PaymentInstruction' ||
            routename === 'editPaymentInstruction',
        }"
      >
        <router-link :to="{ name: 'PaymentInstruction' }" class="nav-link">
          <img
            src="@/assets/ic-manage-account_color.svg"
            alt
            class="px-2"
            v-if="
              payment_instruction ||
              routename === 'PaymentInstruction' ||
              routename === 'editPaymentInstruction'
            "
          />
          <img
            src="@/assets/ic-manage-account_bw.svg"
            alt
            class="px-2"
            v-else-if="
              routename != 'PaymentInstruction' &&
              routename != 'editPaymentInstruction' &&
              !payment_instruction
            "
          />
          <span>Payment Instruction</span>
        </router-link>
      </li>
      <li
        v-show="
          session.role == 'finance' ||
          session.role == 'refund' ||
          session.role == 'superadmin'
        "
        @mouseover="finance = true"
        @mouseleave="finance = false"
        class="nav-item"
        :class="{
          'active border-right-active':
            routename === 'PaymentMethod' ||
            routename === 'createPaymentMethod' ||
            routename === 'editPaymentMethod' ||
            routename === 'createProductLocation' ||
            routename === 'editProductLocation',
        }"
      >
        <router-link :to="{ name: 'PaymentMethod' }" class="nav-link">
          <img
            src="@/assets/ic-manage-account_color.svg"
            alt
            class="px-2"
            v-if="
              finance ||
              routename === 'PaymentMethod' ||
              routename === 'createPaymentMethod' ||
              routename === 'editPaymentMethod' ||
              routename === 'createProductLocation' ||
              routename === 'editProductLocation'
            "
          />
          <img
            src="@/assets/ic-manage-account_bw.svg"
            alt
            class="px-2"
            v-else-if="
              routename != 'createProductLocation' &&
              routename != 'editProductLocation' &&
              routename != 'PaymentMethod' &&
              routename != 'createPaymentMethod' &&
              routename != 'editPaymentMethod' &&
              !finance
            "
          />
          <span>Payment Aggregator</span>
        </router-link>
      </li>
    </div>

    <div
      v-show="
        session.role == 'finance' ||
        session.role == 'ce' ||
        session.role == 'refund' ||
        session.role == 'superadmin'
      "
    >
      <hr class="sidebar-divider" />
      <div class="sidebar-heading">PPOB</div>
      <li
        class="nav-item"
        @mouseover="ppob = true"
        @mouseleave="ppob = false"
        :class="{
          'active border-right-active-dropdown':
            routename === 'MasterProvider' ||
            routename === 'createMasterProvider' ||
            routename === 'editMasterProvider'||
            routename === 'PPOBProduct' ||
            routename === 'createPPOBProduct' ||
            routename === 'editPPOBProduct' ||
            routename === 'PPOBTransaction',
        }"
      >
        <a
          class="nav-link collapsed"
          href="#"
          data-toggle="collapse"
          data-target="#collapsePPOB"
          aria-expanded="true"
          aria-controls="collapsePPOB"
        >
          <img
            src="@/assets/ic-manage-account_color.svg"
            alt
            class="px-2"
            v-if="
              ppob ||
              routename === 'MasterProvider' ||
              routename === 'createMasterProvider' ||
              routename === 'editMasterProvider' ||
              routename === 'PPOBProduct' ||
              routename === 'createPPOBProduct' ||
              routename === 'editPPOBProduct' ||
              routename === 'PPOBTransaction'
            "
          />
          <img
            src="@/assets/ic-manage-account_bw.svg"
            alt
            class="px-2"
            v-else-if="
              routename != 'MasterProvider' &&
              routename != 'createMasterProvider' &&
              routename != 'editMasterProvider' &&
              routename != 'PPOBProduct' &&
              routename != 'createPPOBProduct' &&
              routename != 'editPPOBProduct' &&
              routename != 'PPOBTransaction' &&
              !ppob
            "
          />
          <span>PPOB</span>
        </a>
        <div
          id="collapsePPOB"
          class="collapse"
          aria-labelledby="headingPages"
          data-parent="#accordionSidebar"
          :class="{
            show:
              routename === 'MasterProvider' ||
              routename === 'createMasterProvider' ||
              routename === 'editMasterProvider' ||
              routename === 'PPOBProduct' ||
              routename === 'createPPOBProduct' ||
              routename === 'editPPOBProduct' ||
              routename === 'PPOBTransaction'
          }"
        >
          <div class="bg-white collapse-inner text-left">
            <router-link
              :to="{ name: 'MasterProvider' }"
              :class="{
                'active border-right-active':
                  routename === 'MasterProvider' ||
                  routename === 'createMasterProvider' ||
                  routename === 'editMasterProvider'
              }"
              class="collapse-item"
              >Master Provider</router-link
            >
            <router-link
              :to="{ name: 'PPOBProduct' }"
              :class="{
                'active border-right-active':
                  routename === 'PPOBProduct' ||
                  routename === 'createPPOBProduct' ||
                  routename === 'editPPOBProduct'
              }"
              class="collapse-item"
              >Products</router-link
            >
            <router-link
              :to="{ name: 'PPOBTransaction' }"
              :class="{
                'active border-right-active':
                  routename === 'PPOBTransaction'
              }"
              class="collapse-item"
              >Transactions</router-link
            >
          </div>
        </div>
      </li>
    </div>

    <!-- Heading -->
    <div v-show="session.role == 'marketing' || session.role == 'superadmin'">
      <hr class="sidebar-divider" />
      <div class="sidebar-heading">Marketing</div>
      <li
        @mouseover="article = true"
        @mouseleave="article = false"
        class="nav-item"
        :class="{
          'active border-right-active':
            routename === 'Article' ||
            routename === 'createArticle' ||
            routename === 'editArticle',
        }"
      >
        <router-link :to="{ name: 'Article' }" class="nav-link">
          <img
            src="@/assets/ic-manage-account_color.svg"
            alt
            class="px-2"
            v-if="
              article ||
              routename === 'Article' ||
              routename === 'createArticle' ||
              routename === 'editArticle'
            "
          />
          <img
            src="@/assets/ic-manage-account_bw.svg"
            alt
            class="px-2"
            v-else-if="
              routename != 'Article' &&
              routename != 'createArticle' &&
              routename != 'editArticle' &&
              !article
            "
          />
          <span>Article</span>
        </router-link>
      </li>
      <li
        @mouseover="promo_voucher_setting = true"
        @mouseleave="promo_voucher_setting = false"
        class="nav-item"
        :class="{
          'active border-right-active-dropdown':
            routename === 'Voucher' ||
            routename === 'ReservationLog' ||
            routename === 'MyVoucherTab' ||
            routename === 'ImageURLGenerator' ||
            routename === 'CreateImageURLGenerator' ||
            routename === 'EditImageURLGenerator' ||
            routename === 'SpecialVoucher',
        }"
      >
        <a
          class="nav-link collapsed"
          href="#"
          data-toggle="collapse"
          data-target="#collapsePromoVoucherSetting"
          aria-expanded="true"
          aria-controls="collapsePromoVoucherSetting"
        >
          <img
            src="@/assets/ic-manage-account_color.svg"
            alt
            class="px-2"
            v-if="
              promo_voucher_setting ||
              routename === 'Voucher' ||
              routename === 'ReservationLog' ||
              routename === 'MyVoucherTab' ||
              routename === 'ImageURLGenerator' ||
              routename === 'CreateImageURLGenerator' ||
              routename === 'EditImageURLGenerator' ||
              routename === 'SpecialVoucher'
            "
          />
          <img
            src="@/assets/ic-manage-account_bw.svg"
            alt
            class="px-2"
            v-else-if="
              routename != 'Voucher' &&
              routename != 'ReservationLog' &&
              routename != 'MyVoucherTab' &&
              routename != 'ImageURLGenerator' &&
              routename !== 'CreateImageURLGenerator' &&
              routename !== 'EditImageURLGenerator' &&
              routename !== 'SpecialVoucher' &&
              !promo_voucher_setting
            "
          />
          <span>Promo</span>
        </a>
        <div
          id="collapsePromoVoucherSetting"
          class="collapse"
          aria-labelledby="headingPages"
          data-parent="#accordionSidebar"
          :class="{
            show:
              routename === 'Voucher' ||
              routename === 'ReservationLog' ||
              routename === 'MyVoucherTab' ||
              routename === 'ImageURLGenerator' ||
              routename === 'CreateImageURLGenerator' ||
              routename === 'EditImageURLGenerator' ||
              routename === 'SpecialVoucher',
          }"
        >
          <div class="bg-white collapse-inner text-left">
            <router-link
              :to="{ name: 'Voucher' }"
              :class="{
                'active border-right-active':
                  routename === 'Voucher',
              }"
              class="collapse-item"
            >
              Voucher
            </router-link>
            <router-link
              :to="{ name: 'ReservationLog' }"
              :class="{
                'active border-right-active':
                  routename === 'ReservationLog',
              }"
              class="collapse-item"
            >
              Reservation Log
            </router-link>
            <router-link
              :to="{ name: 'MyVoucherTab' }"
              :class="{
                'active border-right-active':
                  routename === 'MyVoucherTab',
              }"
              class="collapse-item"
            >
              My Voucher Tab
            </router-link>
            <router-link
              :to="{ name: 'SpecialVoucher' }"
              :class="{
                'active border-right-active':
                  routename === 'SpecialVoucher',
              }"
              class="collapse-item"
            >
              Special Voucher
            </router-link>
            <router-link
              :to="{ name: 'ImageURLGenerator' }"
              :class="{
                'active border-right-active':
                  routename === 'ImageURLGenerator' ||
                  routename === 'CreateImageURLGenerator' ||
                  routename === 'EditImageURLGenerator',
              }"
              class="collapse-item"
            >
              Image URL Generator
            </router-link>
          </div>
        </div>
      </li>
      <!-- <li
        class="nav-item"
        @mouseover="paxel_market = true"
        @mouseleave="paxel_market = false"
        :class="{ 'active border-right-active-dropdown': routename === 'MessageLog' ||routename === 'MessageTemplate' ||routename === 'MessageTest' ||routename === 'ProductMaster' || routename === 'createCategory'|| routename === 'editCategory' || routename === 'CategoryProduct'||routename === 'createSubCategory'||routename === 'editSubCategory' || routename === 'SubCategoryProduct' || routename === 'createProductMaster'|| routename === 'editProductMaster' }"
      >
        <a
          class="nav-link collapsed"
          href="#"
          data-toggle="collapse"
          data-target="#collapsePaxelMarket"
          aria-expanded="true"
          aria-controls="collapsePaxelMarket"
        >
          <img
            src="@/assets/icon-paxel-market.svg"
            alt
            class="px-2"
            v-if="paxel_market || routename === 'MessageLog' ||routename === 'MessageTemplate' ||routename === 'MessageTest' || routename === 'ProductMaster' || routename === 'createCategory'|| routename === 'editCategory' || routename === 'CategoryProduct'||routename === 'createSubCategory'||routename === 'editSubCategory' || routename === 'SubCategoryProduct' || routename === 'createProductMaster'|| routename === 'editProductMaster'"
          />
          <img
            src="@/assets/icon-paxel-market-inactive.svg"
            alt
            class="px-2"
            v-else-if="routename != 'MessageLog' &&routename != 'MessageTemplate' &&routename != 'MessageTest' &&routename != 'ProductMaster' && routename != 'createCategory'&& routename != 'editCategory' && routename != 'CategoryProduct'&&routename != 'createSubCategory'&&routename != 'editSubCategory' && routename != 'SubCategoryProduct' && routename != 'createProductMaster'&& routename != 'editProductMaster' && !paxel_market"
          />
          <span>Paxel Market</span>
        </a>
        <div
          id="collapsePaxelMarket"
          class="collapse"
          :class="{ 'show': routename === 'MessageLog' ||routename === 'MessageTemplate' ||routename === 'MessageTest' || routename === 'ProductMaster' || routename === 'createCategory'|| routename === 'editCategory' || routename === 'CategoryProduct'||routename === 'createSubCategory'||routename === 'editSubCategory' || routename === 'SubCategoryProduct' || routename === 'createProductMaster'|| routename === 'editProductMaster' }"
          aria-labelledby="headingPages"
          data-parent="#accordionSidebar"
        >
          <div class="bg-white collapse-inner text-left">
            <router-link
              :to="{name: 'MessageLog'}"
              :class="{ 'active border-right-active': routename === 'MessageLog' }"
              class="collapse-item"
            >Message Log</router-link>
            <router-link
              :to="{name: 'MessageTemplate'}"
              :class="{ 'active border-right-active': routename === 'MessageTemplate' }"
              class="collapse-item"
            >Message Template</router-link>
            <router-link
              :to="{name: 'MessageTest'}"
              :class="{ 'active border-right-active': routename === 'MessageTest' }"
              class="collapse-item"
            >Message Test</router-link>
            <router-link
              :to="{name: 'CategoryProduct'}"
              :class="{ 'active border-right-active': routename === 'CategoryProduct' ||routename === 'createCategory'||routename === 'editCategory' }"
              class="collapse-item"
            >Category Product</router-link>
            <router-link
              :to="{name: 'SubCategoryProduct'}"
              :class="{ 'active border-right-active': routename === 'SubCategoryProduct' || routename === 'createSubCategory'|| routename === 'editSubCategory' }"
              class="collapse-item"
            >Sub Category Product</router-link>
            <router-link
              :to="{name: 'ProductMaster'}"
              :class="{ 'active border-right-active': routename === 'ProductMaster' || routename === 'createProductMaster'|| routename === 'editProductMaster' }"
              class="collapse-item"
            >Product Master</router-link>
          </div>
        </div>
      </li> -->
      <li
        class="nav-item"
        @mouseover="paxelco = true"
        @mouseleave="paxelco = false"
        :class="{
          'active border-right-active-dropdown':
            routename === 'editGuestBook' ||
            routename === 'bannerLocker' ||
            routename === 'createBannerLocker' ||
            routename === 'editBannerLocker' ||
            routename === 'servicesLocker' ||
            routename === 'createServicesLocker' ||
            routename === 'editServicesLocker' ||
            routename === 'bannerMitraPaxel' ||
            routename === 'customerList' ||
            routename === 'detailCustomer' ||
            routename === 'TncContent' ||
            routename === 'createTncContent' ||
            routename === 'editTncContent' ||
            routename === 'TncCategory' ||
            routename === 'createTncCategory' ||
            routename === 'editTncCategory' ||
            routename === 'PartnerList' ||
            routename === 'createPartnerList' ||
            routename === 'editPartnerList' ||
            routename === 'bannerOurPartner' ||
            routename === 'createBannerOurPartner' ||
            routename === 'editBannerOurPartner' ||
            routename === 'AntarkankebaikanPartner' ||
            routename === 'createAntarkankebaikanPartner' ||
            routename === 'editAntarkankebaikanPartner' ||
            routename === 'editBannerAntarkanKebaikan' ||
            routename === 'createPartnershipKontak' ||
            routename === 'editPartnershipKontak' ||
            routename === 'PartnershipKontak' ||
            routename === 'editPartnershipBanner' ||
            routename === 'editBannerNewsPromo' ||
            routename === 'editBannerOurService' ||
            routename === 'editBannerAboutUs' ||
            routename === 'Banner' ||
            routename === 'createBanner' ||
            routename === 'editBanner' ||
            routename === 'PartnershipExcellence' ||
            routename === 'PartnershipTestimonial' ||
            routename === 'createPartnershipExcellence' ||
            routename === 'editPartnershipExcellence' ||
            routename === 'createPartnershipTestimonial' ||
            routename === 'editPartnershipTestimonial' ||
            routename === 'PartnerList' ||
            routename === 'editPartnerList' ||
            routename === 'createPartnerList' ||
            routename === 'PaxelcoDashboard' ||
            routename === 'OurPartners' ||
            routename === 'createOurPartners' ||
            routename === 'editOurPartners' ||
            routename === 'OurServiceValues' ||
            routename === 'editOurServiceValues' ||
            routename === 'createOurServiceValues' ||
            routename === 'homePage' ||
            routename === 'TncWeb' ||
            routename === 'TncUser' ||
            routename === 'TncHero' ||
            routename === 'FaqCategory' ||
            routename === 'FaqContent' ||
            routename === 'createFaq' ||
            routename === 'editFaq' ||
            routename === 'createFaqCategory' ||
            routename === 'editFaqCategory' ||
            routename === 'createTnc' ||
            routename === 'editTnc' ||
            routename === 'editHomePage' ||
            routename === 'createHomePage' ||
            routename === 'Aboutus' ||
            routename === 'createAboutus' ||
            routename === 'editAboutus' ||
            routename === 'Privacypolicy' ||
            routename === 'editPrivacypolicy' ||
            routename === 'createPrivacypolicy' ||
            routename === 'OurService' ||
            routename === 'createOurService' ||
            routename === 'editOurService' ||
            routename === 'bannerCorpSales' ||
            routename === 'CorpSalesExcellence' ||
            routename === 'CorpSalesTestimonial' ||
            routename === 'createCorpSalesExcellence' ||
            routename === 'editCorpSalesExcellence' ||
            routename === 'createCorpSalesTestimonial' ||
            routename === 'editCorpSalesTestimonial' ||
            routename === 'CorpPartnerList' ||
            routename === 'editCorpPartnerList' ||
            routename === 'createCorpPartnerList'||
            routename === 'BigBanner' ||
            routename === 'FlowBig' ||
            routename === 'BigCustomerList' ||
            routename === 'createBigCustomerList' ||
            routename === 'editBigCustomerList' ||
            routename === 'BigExcellence' ||
            routename === 'createBigExcellence' ||
            routename === 'footNote'||
            routename === 'editBannerOurService'||
            routename === 'editBigExcellence'||
            routename === 'Captcha'||
            routename === 'createCaptcha' ||
            routename === 'editCaptcha' ||
            routename === 'BigRegistrationButton' ||
            routename === 'GlobalSearch'||
            routename === 'createGlobalSearch' ||
            routename === 'editGlobalSearch' ||
            routename === 'PaxelMarketMainHeader' ||
            routename === 'PaxelMarketMeta' ||
            routename === 'PaxelMarketBasicService' ||
            routename === 'createPaxelMarketBasicService' ||
            routename === 'editPaxelMarketBasicService' ||
            routename === 'PaxelMarketMainFeatures' ||
            routename === 'createPaxelMarketMainFeatures' ||
            routename === 'editPaxelMarketMainFeatures' ||
            routename === 'PaxelMarketJoinProcedure' ||
            routename === 'createPaxelMarketJoinProcedure' ||
            routename === 'editPaxelMarketJoinProcedure' ||
            routename === 'PaxelMarketSOP' ||
            routename === 'createPaxelMarketSOP' ||
            routename === 'editPaxelMarketSOP' ||
            routename === 'PaxelMarketPartners' ||
            routename === 'createPaxelMarketPartners' ||
            routename === 'editPaxelMarketPartners'
        }"
      >
        <a
          class="nav-link collapsed"
          href="#"
          data-toggle="collapse"
          data-target="#collapsePaxelco"
          aria-expanded="true"
          aria-controls="collapsePaxelco"
        >
          <img
            src="@/assets/ic-manage-account_color.svg"
            alt
            class="px-2"
            v-if="
              paxelco ||
              routename === 'editGuestBook' ||
              routename === 'bannerLocker' ||
              routename === 'createBannerLocker' ||
              routename === 'editBannerLocker' ||
              routename === 'servicesLocker' ||
              routename === 'createServicesLocker' ||
              routename === 'editServicesLocker' ||
              routename === 'bannerMitraPaxel' ||
              routename === 'customerList' ||
              routename === 'detailCustomer' ||
              routename === 'TncContent' ||
              routename === 'createTncContent' ||
              routename === 'editTncContent' ||
              routename === 'TncCategory' ||
              routename === 'createTncCategory' ||
              routename === 'editTncCategory' ||
              routename === 'PartnerList' ||
              routename === 'createPartnerList' ||
              routename === 'editPartnerList' ||
              routename === 'bannerOurPartner' ||
              routename === 'createBannerOurPartner' ||
              routename === 'editBannerOurPartner' ||
              routename === 'AntarkankebaikanPartner' ||
              routename === 'createAntarkankebaikanPartner' ||
              routename === 'editAntarkankebaikanPartner' ||
              routename === 'editBannerAntarkanKebaikan' ||
              routename === 'createPartnershipKontak' ||
              routename === 'editPartnershipKontak' ||
              routename === 'PartnershipKontak' ||
              routename === 'editPartnershipBanner' ||
              routename === 'editBannerNewsPromo' ||
              routename === 'editBannerOurService' ||
              routename === 'editBannerAboutUs' ||
              routename === 'Banner' ||
              routename === 'createBanner' ||
              routename === 'editBanner' ||
              routename === 'PartnershipExcellence' ||
              routename === 'PartnershipTestimonial' ||
              routename === 'createPartnershipExcellence' ||
              routename === 'editPartnershipExcellence' ||
              routename === 'createPartnershipTestimonial' ||
              routename === 'editPartnershipTestimonial' ||
              routename === 'PartnerList' ||
              routename === 'editPartnerList' ||
              routename === 'createPartnerList' ||
              routename === 'PaxelcoDashboard' ||
              routename === 'OurPartners' ||
              routename === 'createOurPartners' ||
              routename === 'editOurPartners' ||
              routename === 'OurServiceValues' ||
              routename === 'editOurServiceValues' ||
              routename === 'createOurServiceValues' ||
              routename === 'homePage' ||
              routename === 'TncWeb' ||
              routename === 'TncUser' ||
              routename === 'TncHero' ||
              routename === 'FaqCategory' ||
              routename === 'FaqContent' ||
              routename === 'createFaq' ||
              routename === 'editFaq' ||
              routename === 'createFaqCategory' ||
              routename === 'editFaqCategory' ||
              routename === 'createTnc' ||
              routename === 'editTnc' ||
              routename === 'editHomePage' ||
              routename === 'createHomePage' ||
              routename === 'Aboutus' ||
              routename === 'createAboutus' ||
              routename === 'editAboutus' ||
              routename === 'Privacypolicy' ||
              routename === 'editPrivacypolicy' ||
              routename === 'createPrivacypolicy' ||
              routename === 'OurService' ||
              routename === 'createOurService' ||
              routename === 'editOurService' ||
              routename === 'bannerCorpSales' ||
              routename === 'CorpSalesExcellence' ||
              routename === 'CorpSalesTestimonial' ||
              routename === 'createCorpSalesExcellence' ||
              routename === 'editCorpSalesExcellence' ||
              routename === 'createCorpSalesTestimonial' ||
              routename === 'editCorpSalesTestimonial' ||
              routename === 'CorpPartnerList' ||
              routename === 'editCorpPartnerList' ||
              routename === 'createCorpPartnerList' ||
              routename === 'BigBanner' ||
              routename === 'FlowBig' ||
              routename === 'BigCustomerList' ||
              routename === 'createBigCustomerList' ||
              routename === 'editBigCustomerList' ||
              routename === 'BigExcellence' ||
              routename === 'createBigExcellence' ||
              routename === 'footNote'||
              routename === 'editBannerOurService'||
              routename === 'editBigExcellence'||
              routename === 'Captcha'||
              routename === 'createCaptcha' ||
              routename === 'editCaptcha' ||
              routename === 'BigRegistrationButton' ||
              routename === 'GlobalSearch' ||
              routename === 'createGlobalSearch' ||
              routename === 'editGlobalSearch' ||
              routename === 'PaxelMarketMainHeader' ||
              routename === 'PaxelMarketMeta' ||
              routename === 'PaxelMarketBasicService' ||
              routename === 'createPaxelMarketBasicService' ||
              routename === 'editPaxelMarketBasicService' ||
              routename === 'PaxelMarketMainFeatures' ||
              routename === 'createPaxelMarketMainFeatures' ||
              routename === 'editPaxelMarketMainFeatures' ||
              routename === 'PaxelMarketJoinProcedure' ||
              routename === 'createPaxelMarketJoinProcedure' ||
              routename === 'editPaxelMarketJoinProcedure' ||
              routename === 'PaxelMarketSOP' ||
            routename === 'createPaxelMarketSOP' ||
            routename === 'editPaxelMarketSOP' ||
              routename === 'PaxelMarketPartners' ||
              routename === 'createPaxelMarketPartners' ||
              routename === 'editPaxelMarketPartners'
            "
          />
          <img
            src="@/assets/ic-manage-account_bw.svg"
            alt
            class="px-2"
            v-else-if="
              routename != 'editGuestBook' &&
              routename != 'bannerLocker' &&
              routename != 'createBannerLocker' &&
              routename != 'editBannerLocker' &&
              routename != 'servicesLocker' &&
              routename != 'createServicesLocker' &&
              routename != 'editServicesLocker' &&
              routename != 'bannerMitraPaxel' &&
              routename != 'customerList' &&
              routename != 'detailCustomer' &&
              routename != 'TncContent' &&
              routename != 'createTncContent' &&
              routename != 'editTncContent' &&
              routename != 'TncCategory' &&
              routename != 'createTncCategory' &&
              routename != 'editTncCategory' &&
              routename != 'PartnerList' &&
              routename != 'createPartnerList' &&
              routename != 'editPartnerList' &&
              routename != 'bannerOurPartner' &&
              routename != 'createBannerOurPartner' &&
              routename != 'editBannerOurPartner' &&
              routename != 'AntarkankebaikanPartner' &&
              routename != 'createAntarkankebaikanPartner' &&
              routename != 'editAntarkankebaikanPartner' &&
              routename != 'editBannerAntarkanKebaikan' &&
              routename != 'createPartnershipKontak' &&
              routename != 'editPartnershipKontak' &&
              routename != 'PartnershipKontak' &&
              routename != 'editPartnershipBanner' &&
              routename != 'editBannerNewsPromo' &&
              routename != 'editBannerOurService' &&
              routename != 'editBannerAboutUs' &&
              routename != 'Banner' &&
              routename != 'createBanner' &&
              routename != 'editBanner' &&
              routename != 'PartnershipExcellence' &&
              routename != 'PartnershipTestimonial' &&
              routename != 'createPartnershipExcellence' &&
              routename != 'editPartnershipExcellence' &&
              routename != 'createPartnershipTestimonial' &&
              routename != 'editPartnershipTestimonial' &&
              routename != 'PartnerList' &&
              routename != 'editPartnerList' &&
              routename != 'createPartnerList' &&
              routename != 'PaxelcoDashboard' &&
              routename != 'OurPartners' &&
              routename != 'createOurPartners' &&
              routename != 'editOurPartners' &&
              routename != 'OurServiceValues' &&
              routename != 'editOurServiceValues' &&
              routename != 'createOurServiceValues' &&
              routename != 'homePage' &&
              routename != 'TncWeb' &&
              routename != 'TncUser' &&
              routename != 'TncHero' &&
              routename != 'FaqCategory' &&
              routename != 'FaqContent' &&
              routename != 'createFaq' &&
              routename != 'editFaq' &&
              routename != 'createFaqCategory' &&
              routename != 'editFaqCategory' &&
              routename != 'createTnc' &&
              routename != 'editTnc' &&
              routename != 'editHomePage' &&
              routename != 'createHomePage' &&
              routename != 'Aboutus' &&
              routename != 'createAboutus' &&
              routename != 'editAboutus' &&
              routename != 'Privacypolicy' &&
              routename != 'editPrivacypolicy' &&
              routename != 'createPrivacypolicy' &&
              routename != 'OurService' &&
              routename != 'createOurService' &&
              routename != 'editOurService' &&
              routename != 'CorpSalesExcellence' &&
              routename != 'CorpSalesTestimonial' &&
              routename != 'createCorpSalesExcellence' &&
              routename != 'editCorpSalesExcellence' &&
              routename != 'createCorpSalesTestimonial' &&
              routename != 'editCorpSalesTestimonial' &&
              routename != 'CorpPartnerList' &&
              routename != 'editCorpPartnerList' &&
              routename != 'createCorpPartnerList' &&
              routename != 'bannerCorpSales' &&
              routename != 'BigBanner' &&
              routename != 'FlowBig' &&
              routename != 'BigCustomerList' &&
              routename != 'createBigCustomerList' &&
              routename != 'editBigCustomerList' &&
              routename != 'BigExcellence' &&
              routename != 'createBigExcellence' &&
              routename != 'editBigExcellence' &&
              routename != 'footNote' &&
              routename != 'editBannerOurService' &&
              routename != 'Captcha'&&
              routename != 'createCaptcha' &&
              routename != 'editCaptcha'&&
              routename != 'BigRegistrationButton' &&
              routename != 'GlobalSearch' &&
              routename != 'createGlobalSearch' &&
              routename != 'editGlobalSearch' &&
              routename != 'PaxelMarketMainHeader' &&
              routename != 'PaxelMarketMeta' &&
              routename != 'PaxelMarketBasicService' &&
              routename != 'createPaxelMarketBasicService' &&
              routename != 'editPaxelMarketBasicService' &&
              routename != 'PaxelMarketMainFeatures' &&
              routename != 'createPaxelMarketMainFeatures' &&
              routename != 'editPaxelMarketMainFeatures' &&
              routename != 'PaxelMarketJoinProcedure' &&
              routename != 'createPaxelMarketJoinProcedure' &&
              routename != 'editPaxelMarketJoinProcedure' &&
              routename != 'PaxelMarketSOP' &&
              routename != 'createPaxelMarketSOP' &&
              routename != 'editPaxelMarketSOP' &&
              routename != 'PaxelMarketPartners' &&
              routename != 'createPaxelMarketPartners' &&
              routename != 'editPaxelMarketPartners' &&
              !paxelco
            "
          />
          <span>Website Content</span>
        </a>
        <div
          id="collapsePaxelco"
          class="collapse"
          aria-labelledby="headingPages"
          data-parent="#accordionSidebar"
          :class="{
            show:
              routename === 'editGuestBook' ||
              routename === 'bannerLocker' ||
              routename === 'createBannerLocker' ||
              routename === 'editBannerLocker' ||
              routename === 'servicesLocker' ||
              routename === 'createServicesLocker' ||
              routename === 'editServicesLocker' ||
              routename === 'bannerMitraPaxel' ||
              routename === 'customerList' ||
              routename === 'detailCustomer' ||
              routename === 'TncContent' ||
              routename === 'createTncContent' ||
              routename === 'editTncContent' ||
              routename === 'TncCategory' ||
              routename === 'createTncCategory' ||
              routename === 'editTncCategory' ||
              routename === 'PartnerList' ||
              routename === 'createPartnerList' ||
              routename === 'editPartnerList' ||
              routename === 'bannerOurPartner' ||
              routename === 'createBannerOurPartner' ||
              routename === 'editBannerOurPartner' ||
              routename === 'AntarkankebaikanPartner' ||
              routename === 'createAntarkankebaikanPartner' ||
              routename === 'editAntarkankebaikanPartner' ||
              routename === 'editBannerAntarkanKebaikan' ||
              routename === 'createPartnershipKontak' ||
              routename === 'editPartnershipKontak' ||
              routename === 'PartnershipKontak' ||
              routename === 'editPartnershipBanner' ||
              routename === 'editBannerNewsPromo' ||
              routename === 'editBannerOurService' ||
              routename === 'editBannerAboutUs' ||
              routename === 'Banner' ||
              routename === 'createBanner' ||
              routename === 'editBanner' ||
              routename === 'PartnershipExcellence' ||
              routename === 'PartnershipTestimonial' ||
              routename === 'createPartnershipExcellence' ||
              routename === 'editPartnershipExcellence' ||
              routename === 'createPartnershipTestimonial' ||
              routename === 'editPartnershipTestimonial' ||
              routename === 'PartnerList' ||
              routename === 'editPartnerList' ||
              routename === 'createPartnerList' ||
              routename === 'PaxelcoDashboard' ||
              routename === 'OurPartners' ||
              routename === 'createOurPartners' ||
              routename === 'editOurPartners' ||
              routename === 'TncWeb' ||
              routename === 'TncUser' ||
              routename === 'TncHero' ||
              routename === 'OurServiceValues' ||
              routename === 'editOurServiceValues' ||
              routename === 'createOurServiceValues' ||
              routename === 'homePage' ||
              routename === 'Tnc' ||
              routename === 'FaqCategory' ||
              routename === 'FaqContent' ||
              routename === 'createFaq' ||
              routename === 'editFaq' ||
              routename === 'createFaqCategory' ||
              routename === 'editFaqCategory' ||
              routename === 'createTnc' ||
              routename === 'editTnc' ||
              routename === 'editHomePage' ||
              routename === 'createHomePage' ||
              routename === 'Aboutus' ||
              routename === 'createAboutus' ||
              routename === 'editAboutus' ||
              routename === 'Privacypolicy' ||
              routename === 'editPrivacypolicy' ||
              routename === 'createPrivacypolicy' ||
              routename === 'OurService' ||
              routename === 'createOurService' ||
              routename === 'editOurService' ||
              routename === 'CorpSalesExcellence' ||
              routename === 'CorpSalesTestimonial' ||
              routename === 'createCorpSalesExcellence' ||
              routename === 'editCorpSalesExcellence' ||
              routename === 'createCorpSalesTestimonial' ||
              routename === 'editCorpSalesTestimonial' ||
              routename === 'bannerCorpSales' ||
              routename === 'CorpPartnerList' ||
              routename === 'editCorpPartnerList' ||
              routename === 'createCorpPartnerList' ||
              routename === 'BigBanner' ||
              routename === 'FlowBig' ||
              routename === 'BigCustomerList' ||
              routename === 'createBigCustomerList' ||
              routename === 'editBigCustomerList' ||
              routename === 'BigExcellence' ||
              routename === 'createBigExcellence' ||
              routename === 'footNote'||
              routename === 'editBannerOurService'||
              routename === 'editBigExcellence'||
              routename === 'Captcha'||
              routename === 'createCaptcha' ||
              routename === 'editCaptcha' ||
              routename === 'editBannerDownload' ||
              routename === 'BigRegistrationButton' ||
              routename === 'PaxelRecycleMeta' ||
              routename === 'PaxelRecycleBanner' ||
              routename === 'PaxelRecycleReason' ||
              routename === 'createPaxelRecycleReason' ||
              routename === 'editPaxelRecycleReason' ||
              routename === 'PaxelRecycleWasteType' ||
              routename === 'createPaxelRecycleWasteType' ||
              routename === 'editPaxelRecycleWasteType' ||
              routename === 'PaxelRecycleBeforeSending' ||
              routename === 'PaxelRecycleHowTo' ||
              routename === 'createPaxelRecycleHowTo' ||
              routename === 'editPaxelRecycleHowTo' ||
              routename === 'PaxelRecycleTutorial' ||
              routename === 'PaxelRecycleCoverage' ||
              routename === 'PaxelRecycleMoreInfo' ||
              routename === 'PejuangOnlineBanner' ||
              routename === 'GlobalSearch' ||
              routename === 'createGlobalSearch' ||
              routename === 'editGlobalSearch' ||
              routename === 'PaxelMarketMainHeader' ||
              routename === 'PaxelMarketMeta' ||
              routename === 'PaxelMarketBasicService' ||
              routename === 'createPaxelMarketBasicService' ||
              routename === 'editPaxelMarketBasicService' ||
              routename === 'PaxelMarketMainFeatures' ||
              routename === 'createPaxelMarketMainFeatures' ||
              routename === 'editPaxelMarketMainFeatures' ||
              routename === 'PaxelMarketJoinProcedure' ||
              routename === 'createPaxelMarketJoinProcedure' ||
              routename === 'editPaxelMarketJoinProcedure' ||
              routename === 'PaxelMarketSOP' ||
            routename === 'createPaxelMarketSOP' ||
            routename === 'editPaxelMarketSOP' ||
              routename === 'PaxelMarketPartners' ||
              routename === 'createPaxelMarketPartners' ||
              routename === 'editPaxelMarketPartners',
          }"
        >
          <div class="bg-white collapse-inner text-left">
            <li class="pl-1">
              <a
                class="nav-link collapsed pl-5"
                data-toggle="collapse"
                href="#HomepageCollapse"
                aria-expanded="true"
                aria-controls="HomepageCollapse"
                :class="{
                  'active border-right-active-dropdown':
                    routename === 'homePage' ||
                    routename === 'editHomePage' ||
                    routename === 'createHomePage' ||
                    routename === 'footNote' ||
                    routename === 'PaxelcoDashboard'||
                    routename === 'Captcha'||
                    routename === 'createCaptcha' ||
                    routename === 'editCaptcha',
                }"
              >
                <span
                  :class="{
                    'font-weight-normal secondsub-sidebar':
                      routename != 'homePage' &&
                      routename != 'editHomePage' &&
                      routename != 'createHomePage' &&
                      routename != 'footNote' &&
                      routename != 'PaxelcoDashboard'&&
                      routename != 'Captcha'&&
                      routename != 'createCaptcha' &&
                      routename != 'editCaptcha',
                  }"
                  class="sidebar-normal pl-3"
                  >Homepage</span
                >
              </a>
            </li>
            <div
              class="collapse m-0"
              id="HomepageCollapse"
              :class="{
                show:
                  routename === 'homePage' ||
                  routename === 'editHomePage' ||
                  routename === 'createHomePage' ||
                  routename === 'PaxelcoDashboard',
              }"
            >
              <router-link
                :to="{ name: 'homePage' }"
                :class="{
                  'active border-right-active':
                    routename === 'homePage' ||
                    routename === 'editHomePage' ||
                    routename === 'createHomePage',
                }"
                class="collapse-item"
              >
                <span class="sidebar-normal pl-4">Top Banner</span>
              </router-link>
              <router-link
                :to="{ name: 'PaxelcoDashboard' }"
                :class="{
                  'active border-right-active':
                    routename === 'PaxelcoDashboard',
                }"
                class="collapse-item"
              >
                <span class="sidebar-normal pl-4">Infografis</span>
              </router-link>
              <router-link
                :to="{ name: 'footNote' }"
                :class="{
                  'active border-right-active':
                    routename === 'footNote',
                }"
                class="collapse-item"
              >
                <span class="sidebar-normal pl-4">Footnote</span>
              </router-link>
              <router-link
                :to="{ name: 'Captcha' }"
                :class="{
                  'active border-right-active':
                    routename === 'Captcha'||
                    routename === 'createCaptcha' ||
                    routename === 'editCaptcha',
                }"
                class="collapse-item"
              >
                <span class="sidebar-normal pl-4">Captcha Image</span>
              </router-link>
            </div>
            <li class="pl-1">
              <a
                class="nav-link collapsed pl-5"
                data-toggle="collapse"
                href="#OurServiceCollapse"
                aria-expanded="true"
                aria-controls="OurServiceCollapse"
                :class="{
                  'active border-right-active-dropdown':
                    routename === 'OurService' ||
                    routename === 'createOurService' ||
                    routename === 'editOurService' ||
                    routename === 'editBannerOurService',
                }"
              >
                <span
                  :class="{
                    'font-weight-normal secondsub-sidebar':
                      routename != 'OurService' &&
                      routename != 'createOurService' &&
                      routename != 'editOurService' &&
                      routename != 'editBannerOurService',
                  }"
                  class="sidebar-normal pl-3"
                  >Layanan Kami</span
                >
              </a>
            </li>
            <div
              class="collapse m-0"
              id="OurServiceCollapse"
              :class="{
                show:
                  routename === 'OurService' ||
                  routename === 'createOurService' ||
                  routename === 'editOurService' ||
                  routename === 'editBannerOurService',
              }"
            >
              <router-link
                :to="{ name: 'editBannerOurService' }"
                :class="{
                  'active border-right-active':
                    routename === 'editBannerOurService',
                }"
                class="collapse-item"
              >
                <span class="sidebar-normal pl-4">Banner</span>
              </router-link>
              <router-link
                :to="{ name: 'OurService' }"
                :class="{
                  'active border-right-active':
                    routename === 'OurService' ||
                    routename === 'createOurService' ||
                    routename === 'editOurService',
                }"
                class="collapse-item"
              >
                <span class="sidebar-normal pl-4">Content</span>
              </router-link>
            </div>
            <li class="pl-1">
              <a
                class="nav-link collapsed pl-5"
                data-toggle="collapse"
                href="#AboutUsCollapse"
                aria-expanded="true"
                aria-controls="AboutUsCollapse"
                :class="{
                  'active border-right-active-dropdown':
                    routename === 'Aboutus' ||
                    routename === 'createAboutus' ||
                    routename === 'editAboutus' ||
                    routename === 'editBannerAboutUs',
                }"
              >
                <span
                  :class="{
                    'font-weight-normal secondsub-sidebar':
                      routename != 'Aboutus' &&
                      routename != 'createAboutus' &&
                      routename != 'editAboutus' &&
                      routename != 'editBannerAboutUs',
                  }"
                  class="sidebar-normal pl-3"
                  >Tentang Kami</span
                >
              </a>
            </li>
            <div
              class="collapse m-0"
              id="AboutUsCollapse"
              :class="{
                show:
                  routename === 'Aboutus' ||
                  routename === 'createAboutus' ||
                  routename === 'editAboutus' ||
                  routename === 'editBannerAboutUs',
              }"
            >
              <router-link
                :to="{ name: 'editBannerAboutUs' }"
                :class="{
                  'active border-right-active':
                    routename === 'editBannerAboutUs',
                }"
                class="collapse-item"
              >
                <span class="sidebar-normal pl-4">Banner</span>
              </router-link>
              <router-link
                :to="{ name: 'Aboutus' }"
                :class="{
                  'active border-right-active':
                    routename === 'Aboutus' ||
                    routename === 'createAboutus' ||
                    routename === 'editAboutus',
                }"
                class="collapse-item"
              >
                <span class="sidebar-normal pl-4">Content</span>
              </router-link>
            </div>
            <li class="pl-1">
              <a
                class="nav-link collapsed pl-5"
                data-toggle="collapse"
                href="#PaxelRecycleCollapse"
                aria-expanded="true"
                aria-controls="PaxelRecycleCollapse"
                :class="{
                  'active border-right-active-dropdown':
                    routename === 'PaxelRecycleMeta' ||
                    routename === 'PaxelRecycleBanner' ||
                    routename === 'PaxelRecycleReason' ||
                    routename === 'createPaxelRecycleReason' ||
                    routename === 'editPaxelRecycleReason' ||
                    routename === 'PaxelRecycleWasteType' ||
                    routename === 'createPaxelRecycleWasteType' ||
                    routename === 'editPaxelRecycleWasteType' ||
                    routename === 'PaxelRecycleBeforeSending' ||
                    routename === 'PaxelRecycleHowTo' ||
                    routename === 'createPaxelRecycleHowTo' ||
                    routename === 'editPaxelRecycleHowTo' ||
                    routename === 'PaxelRecycleTutorial' ||
                    routename === 'PaxelRecycleCoverage' ||
                    routename === 'PaxelRecycleMoreInfo',
                }"
              >
                <span
                  :class="{
                    'font-weight-normal secondsub-sidebar':
                      routename != 'PaxelRecycleMeta' &&
                      routename != 'PaxelRecycleBanner' &&
                      routename != 'PaxelRecycleReason' &&
                      routename != 'createPaxelRecycleReason' &&
                      routename != 'editPaxelRecycleReason' &&
                      routename != 'PaxelRecycleWasteType' &&
                      routename != 'createPaxelRecycleWasteType' &&
                      routename != 'editPaxelRecycleWasteType' &&
                      routename != 'PaxelRecycleBeforeSending' &&
                      routename != 'PaxelRecycleHowTo' &&
                      routename != 'createPaxelRecycleHowTo' &&
                      routename != 'editPaxelRecycleHowTo' &&
                      routename != 'PaxelRecycleTutorial' &&
                      routename != 'PaxelRecycleCoverage' &&
                      routename != 'PaxelRecycleMoreInfo',
                  }"
                  class="sidebar-normal pl-3"
                  >Paxel Recycle</span
                >
              </a>
            </li>
            <div
              class="collapse m-0"
              id="PaxelRecycleCollapse"
              :class="{
                show:
                  routename === 'PaxelRecycleMeta' ||
                  routename === 'PaxelRecycleBanner' ||
                  routename === 'PaxelRecycleReason' ||
                  routename === 'createPaxelRecycleReason' ||
                  routename === 'editPaxelRecycleReason'||
                  routename === 'PaxelRecycleWasteType' ||
                  routename === 'createPaxelRecycleWasteType' ||
                  routename === 'editPaxelRecycleWasteType' ||
                  routename === 'PaxelRecycleBeforeSending' ||
                  routename === 'PaxelRecycleHowTo' ||
                  routename === 'createPaxelRecycleHowTo' ||
                  routename === 'editPaxelRecycleHowTo' ||
                  routename === 'PaxelRecycleTutorial' ||
                  routename === 'PaxelRecycleCoverage' ||
                  routename === 'PaxelRecycleMoreInfo',
              }"
            >
              <router-link
                :to="{ name: 'PaxelRecycleMeta' }"
                :class="{
                  'active border-right-active': routename === 'PaxelRecycleMeta',
                }"
                class="collapse-item"
              >
                <span class="sidebar-normal pl-4">Meta</span>
              </router-link>
              <router-link
                :to="{ name: 'PaxelRecycleBanner' }"
                :class="{
                  'active border-right-active': routename === 'PaxelRecycleBanner',
                }"
                class="collapse-item"
              >
                <span class="sidebar-normal pl-4">Banner</span>
              </router-link>
              <router-link
                :to="{ name: 'PaxelRecycleReason' }"
                :class="{
                  'active border-right-active': 
                  routename === 'PaxelRecycleReason' ||
                  routename === 'createPaxelRecycleReason' ||
                  routename === 'editPaxelRecycleReason',
                }"
                class="collapse-item"
              >
                <span class="sidebar-normal pl-4">Why PaxelRecycle</span>
              </router-link>
              <router-link
                :to="{ name: 'PaxelRecycleWasteType' }"
                :class="{
                  'active border-right-active': 
                  routename === 'PaxelRecycleWasteType' ||
                  routename === 'createPaxelRecycleWasteType' ||
                  routename === 'editPaxelRecycleWasteType',
                }"
                class="collapse-item"
              >
                <span class="sidebar-normal pl-4">Waste Type</span>
              </router-link>
              <router-link
                :to="{ name: 'PaxelRecycleBeforeSending' }"
                :class="{
                  'active border-right-active': routename === 'PaxelRecycleBeforeSending',
                }"
                class="collapse-item"
              >
                <span class="sidebar-normal pl-4">Before Sending</span>
              </router-link>
              <router-link
                :to="{ name: 'PaxelRecycleHowTo' }"
                :class="{
                  'active border-right-active': 
                  routename === 'PaxelRecycleHowTo' ||
                  routename === 'createPaxelRecycleHowTo' ||
                  routename === 'editPaxelRecycleHowTo',
                }"
                class="collapse-item"
              >
                <span class="sidebar-normal pl-4">How Tos</span>
              </router-link>
              <router-link
                :to="{ name: 'PaxelRecycleTutorial' }"
                :class="{
                  'active border-right-active': routename === 'PaxelRecycleTutorial'
                }"
                class="collapse-item"
              >
                <span class="sidebar-normal pl-4">Tutorial Video</span>
              </router-link>
              <router-link
                :to="{ name: 'PaxelRecycleCoverage' }"
                :class="{
                  'active border-right-active': routename === 'PaxelRecycleCoverage'
                }"
                class="collapse-item"
              >
                <span class="sidebar-normal pl-4">Coverage</span>
              </router-link>
              <router-link
                :to="{ name: 'PaxelRecycleMoreInfo' }"
                :class="{
                  'active border-right-active': routename === 'PaxelRecycleMoreInfo'
                }"
                class="collapse-item"
              >
                <span class="sidebar-normal pl-4">More Info</span>
              </router-link>
            </div>
            <li class="pl-1">
              <a
                class="nav-link collapsed pl-5"
                data-toggle="collapse"
                href="#PaxelBigCollapse"
                aria-expanded="true"
                aria-controls="PaxelBigCollapse"
                :class="{
                  'active border-right-active-dropdown':
                    routename === 'BigBanner' ||
                    routename === 'FlowBig' ||
                    routename === 'BigCustomerList' ||
                    routename === 'createBigCustomerList' ||
                    routename === 'editBigCustomerList' ||
                    routename === 'BigExcellence' ||
                    routename === 'createBigExcellence' ||
                    routename === 'editBigExcellence' ||
                    routename === 'BigRegistrationButton',
                }"
              >
                <span
                  :class="{
                    'font-weight-normal secondsub-sidebar':
                      routename != 'BigBanner' &&
                      routename != 'FlowBig' &&
                      routename != 'BigCustomerList' &&
                      routename != 'createBigCustomerList' &&
                      routename != 'editBigCustomerList' &&
                      routename != 'BigExcellence' &&
                      routename != 'createBigExcellence' &&
                      routename != 'editBigExcellence' &&
                      routename != 'BigRegistrationButton',
                  }"
                  class="sidebar-normal pl-3"
                  >Paxel Big</span
                >
              </a>
            </li>
            <div
              class="collapse m-0"
              id="PaxelBigCollapse"
              :class="{
                show:
                  routename === 'BigBanner' ||
                  routename === 'FlowBig' ||
                  routename === 'BigCustomerList' ||
                  routename === 'createBigCustomerList' ||
                  routename === 'editBigCustomerList' ||
                  routename === 'BigExcellence' ||
                  routename === 'createBigExcellence' ||
                  routename === 'editBigExcellence' ||
                  routename === 'BigRegistrationButton',
              }"
            >
              <router-link
                :to="{ name: 'BigBanner' }"
                :class="{
                  'active border-right-active': routename === 'BigBanner',
                }"
                class="collapse-item"
              >
                <span class="sidebar-normal pl-4">Banner</span>
              </router-link>
              <router-link
                :to="{ name: 'FlowBig' }"
                :class="{
                  'active border-right-active': routename === 'FlowBig',
                }"
                class="collapse-item"
              >
                <span class="sidebar-normal pl-4">Flow</span>
              </router-link>
              <router-link
                :to="{ name: 'BigCustomerList' }"
                :class="{
                  'active border-right-active':
                    routename === 'BigCustomerList' ||
                    routename === 'createBigCustomerList' ||
                    routename === 'editBigCustomerList',
                }"
                class="collapse-item"
              >
                <span class="sidebar-normal pl-4">Customer List</span>
              </router-link>
              <router-link
                :to="{ name: 'BigExcellence' }"
                :class="{
                  'active border-right-active':
                    routename === 'BigExcellence' ||
                    routename === 'createBigExcellence' ||
                    routename === 'editBigExcellence',
                }"
                class="collapse-item"
              >
                <span class="sidebar-normal pl-4">Keunggulan</span>
              </router-link>
              <router-link
                :to="{ name: 'BigRegistrationButton' }"
                :class="{
                  'active border-right-active':
                    routename === 'BigRegistrationButton',
                }"
                class="collapse-item"
              >
                <span class="sidebar-normal pl-4">Registration Button</span>
              </router-link>
            </div>
            <li class="pl-1">
              <a
                class="nav-link collapsed pl-5"
                data-toggle="collapse"
                href="#PaxelMarketCollapse"
                aria-expanded="true"
                aria-controls="PaxelMarketCollapse"
                :class="{
                  'active border-right-active-dropdown':
                    routename === 'PaxelMarketMainHeader' ||
                    routename === 'PaxelMarketMeta' ||
                    routename === 'PaxelMarketBasicService' ||
                    routename === 'createPaxelMarketBasicService' ||
                    routename === 'editPaxelMarketBasicService' ||
                    routename === 'PaxelMarketMainFeatures' ||
                    routename === 'createPaxelMarketMainFeatures' ||
                    routename === 'editPaxelMarketMainFeatures' ||
                    routename === 'PaxelMarketJoinProcedure' ||
                    routename === 'createPaxelMarketJoinProcedure' ||
                    routename === 'editPaxelMarketJoinProcedure' ||
                    routename === 'PaxelMarketSOP' ||
            routename === 'createPaxelMarketSOP' ||
            routename === 'editPaxelMarketSOP' ||
                    routename === 'PaxelMarketPartners' ||
                    routename === 'createPaxelMarketPartners' ||
                    routename === 'editPaxelMarketPartners',
                }"
              >
                <span
                  :class="{
                    'font-weight-normal secondsub-sidebar':
                      routename != 'PaxelMarketMainHeader' &&
                      routename != 'PaxelMarketMeta' &&
                      routename != 'PaxelMarketBasicService' &&
                      routename != 'createPaxelMarketBasicService' &&
                      routename != 'editPaxelMarketBasicService' &&
                      routename != 'PaxelMarketMainFeatures' &&
                      routename != 'createPaxelMarketMainFeatures' &&
                      routename != 'editPaxelMarketMainFeatures' &&
                      routename != 'PaxelMarketJoinProcedure' &&
                      routename != 'createPaxelMarketJoinProcedure' &&
                      routename != 'editPaxelMarketJoinProcedure' &&
                      routename != 'PaxelMarketSOP' &&
              routename != 'createPaxelMarketSOP' &&
              routename != 'editPaxelMarketSOP' &&
                      routename != 'PaxelMarketPartners',
                  }"
                  class="sidebar-normal pl-3"
                  >Paxel Market</span
                >
              </a>
            </li>
            <div
              class="collapse m-0"
              id="PaxelMarketCollapse"
              :class="{
                show:
                  routename === 'PaxelMarketMainHeader' ||
                  routename === 'PaxelMarketMeta' ||
                  routename === 'PaxelMarketBasicService' ||
                  routename === 'createPaxelMarketBasicService' ||
                  routename === 'editPaxelMarketBasicService' ||
                  routename === 'PaxelMarketMainFeatures' ||
                  routename === 'createPaxelMarketMainFeatures' ||
                  routename === 'editPaxelMarketMainFeatures' ||
                  routename === 'PaxelMarketJoinProcedure' ||
                  routename === 'createPaxelMarketJoinProcedure' ||
                  routename === 'editPaxelMarketJoinProcedure' ||
                  routename === 'PaxelMarketSOP' ||
            routename === 'createPaxelMarketSOP' ||
            routename === 'editPaxelMarketSOP' ||
                  routename === 'PaxelMarketPartners' ||
                  routename === 'createPaxelMarketPartners' ||
                  routename === 'editPaxelMarketPartners',
              }"
            >
              <router-link
                :to="{ name: 'PaxelMarketMainHeader' }"
                :class="{
                  'active border-right-active': routename === 'PaxelMarketMainHeader',
                }"
                class="collapse-item"
              >
                <span class="sidebar-normal pl-4">Main Header</span>
              </router-link>
              <router-link
                :to="{ name: 'PaxelMarketMeta' }"
                :class="{
                  'active border-right-active': routename === 'PaxelMarketMeta',
                }"
                class="collapse-item"
              >
                <span class="sidebar-normal pl-4">Meta</span>
              </router-link>
              <router-link
                :to="{ name: 'PaxelMarketBasicService' }"
                :class="{
                  'active border-right-active':
                    routename === 'PaxelMarketBasicService' ||
                    routename === 'createPaxelMarketBasicService' ||
                    routename === 'editPaxelMarketBasicService',
                }"
                class="collapse-item"
              >
                <span class="sidebar-normal pl-4">Basic Service</span>
              </router-link>
              <router-link
                :to="{ name: 'PaxelMarketMainFeatures' }"
                :class="{
                  'active border-right-active':
                    routename === 'PaxelMarketMainFeatures' ||
                    routename === 'createPaxelMarketMainFeatures' ||
                    routename === 'editPaxelMarketMainFeatures',
                }"
                class="collapse-item"
              >
                <span class="sidebar-normal pl-4">Main Features</span>
              </router-link>
              <router-link
                :to="{ name: 'PaxelMarketJoinProcedure' }"
                :class="{
                  'active border-right-active':
                    routename === 'PaxelMarketJoinProcedure' ||
                    routename === 'createPaxelMarketJoinProcedure' ||
                    routename === 'editPaxelMarketJoinProcedure',
                }"
                class="collapse-item"
              >
                <span class="sidebar-normal pl-4">Join Procedure</span>
              </router-link>
              <router-link
                :to="{ name: 'PaxelMarketSOP' }"
                :class="{
                  'active border-right-active':
                    routename === 'PaxelMarketSOP' ||
                    routename === 'createPaxelMarketSOP' ||
                    routename === 'editPaxelMarketSOP',
                }"
                class="collapse-item"
              >
                <span class="sidebar-normal pl-4">SOP</span>
              </router-link>
              <router-link
                :to="{ name: 'PaxelMarketPartners' }"
                :class="{
                  'active border-right-active':
                    routename === 'PaxelMarketPartners' ||
                    routename === 'createPaxelMarketPartners' ||
                    routename === 'editPaxelMarketPartners',
                }"
                class="collapse-item"
              >
                <span class="sidebar-normal pl-4">Paxel Market Partners</span>
              </router-link>
            </div>
            <li class="pl-1">
              <a
                class="nav-link collapsed pl-5"
                data-toggle="collapse"
                href="#MitraPaxelCollapse"
                aria-expanded="true"
                aria-controls="MitraPaxelCollapse"
                :class="{
                  'active border-right-active-dropdown':
                    routename === 'customerList' ||
                    routename === 'detailCustomer' ||
                    routename === 'bannerMitraPaxel',
                }"
              >
                <span
                  :class="{
                    'font-weight-normal secondsub-sidebar':
                      routename != 'customerList' &&
                      routename != 'detailCustomer' &&
                      routename != 'bannerMitraPaxel',
                  }"
                  class="sidebar-normal pl-3"
                  >Mitra PaxelCo</span
                >
              </a>
            </li>
            <div
              class="collapse m-0"
              id="MitraPaxelCollapse"
              :class="{
                show:
                  routename === 'customerList' ||
                  routename === 'detailCustomer' ||
                  routename === 'bannerMitraPaxel',
              }"
            >
              <router-link
                :to="{ name: 'bannerMitraPaxel' }"
                :class="{
                  'active border-right-active':
                    routename === 'bannerMitraPaxel',
                }"
                class="collapse-item"
              >
                <span class="sidebar-normal pl-4">Banner</span>
              </router-link>
              <router-link
                :to="{ name: 'customerList' }"
                :class="{
                  'active border-right-active':
                    routename === 'customerList' ||
                    routename === 'detailCustomer',
                }"
                class="collapse-item"
              >
                <span class="sidebar-normal pl-4">Customer List</span>
              </router-link>
            </div>
            <li class="pl-1">
              <a
                class="nav-link collapsed pl-5"
                data-toggle="collapse"
                href="#FaqCollapse"
                aria-expanded="true"
                aria-controls="FaqCollapse"
                :class="{
                  'active border-right-active-dropdown':
                    routename === 'FaqCategory' ||
                    routename === 'FaqContent' ||
                    routename === 'createFaq' ||
                    routename === 'editFaq' ||
                    routename === 'createFaqCategory' ||
                    routename === 'editFaqCategory',
                }"
              >
                <span
                  :class="{
                    'font-weight-normal secondsub-sidebar':
                      routename != 'FaqCategory' &&
                      routename != 'FaqContent' &&
                      routename != 'createFaq' &&
                      routename != 'editFaq' &&
                      routename != 'createFaqCategory' &&
                      routename != 'editFaqCategory',
                  }"
                  class="sidebar-normal pl-3"
                  >Bantuan & FAQ</span
                >
              </a>
            </li>
            <div
              class="collapse m-0"
              id="FaqCollapse"
              :class="{
                show:
                  routename === 'FaqCategory' ||
                  routename === 'FaqContent' ||
                  routename === 'createFaq' ||
                  routename === 'editFaq' ||
                  routename === 'createFaqCategory' ||
                  routename === 'editFaqCategory',
              }"
            >
              <router-link
                :to="{ name: 'FaqCategory' }"
                :class="{
                  'active border-right-active':
                    routename === 'FaqCategory' ||
                    routename === 'createFaqCategory' ||
                    routename === 'editFaqCategory',
                }"
                class="collapse-item"
              >
                <span class="sidebar-normal pl-4">FAQ Category</span>
              </router-link>
              <router-link
                :to="{ name: 'FaqContent' }"
                :class="{
                  'active border-right-active':
                    routename === 'FaqContent' ||
                    routename === 'createFaq' ||
                    routename === 'editFaq',
                }"
                class="collapse-item"
              >
                <span class="sidebar-normal pl-4">FAQ Content</span>
              </router-link>
            </div>

            <!-- <router-link
              :to="{name: 'OurServiceValues'}"
              :class="{ 'active border-right-active': routename === 'OurServiceValues' || routename === 'editOurServiceValues'|| routename === 'createOurServiceValues' }"
              class="collapse-item"
            >Our Service Values</router-link>-->
            <li class="pl-1">
              <a
                class="nav-link collapsed pl-5"
                data-toggle="collapse"
                href="#PartnershipColapse"
                aria-expanded="true"
                aria-controls="PartnershipColapse"
                :class="{
                  'active border-right-active-dropdown':
                    routename === 'CorpSalesExcellence' ||
                    routename === 'CorpSalesTestimonial' ||
                    routename === 'createCorpSalesExcellence' ||
                    routename === 'editCorpSalesExcellence' ||
                    routename === 'createCorpSalesTestimonial' ||
                    routename === 'editCorpSalesTestimonial' ||
                    routename === 'bannerCorpSales' ||
                    routename === 'createCorpPartnerList' ||
                    routename === 'editCorpPartnerList' ||
                    routename === 'CorpPartnerList',
                }"
              >
                <span
                  :class="{
                    'font-weight-normal secondsub-sidebar':
                      routename != 'CorpSalesExcellence' &&
                      routename != 'CorpSalesTestimonial' &&
                      routename != 'createCorpSalesExcellence' &&
                      routename != 'editCorpSalesExcellence' &&
                      routename != 'createCorpSalesTestimonial' &&
                      routename != 'editCorpSalesTestimonial' &&
                      routename != 'bannerCorpSales' &&
                      routename != 'createCorpPartnerList' &&
                      routename != 'editCorpPartnerList' &&
                      routename != 'CorpPartnerList',
                  }"
                  class="sidebar-normal pl-3"
                >
                  Corporate Sales &nbsp;
                  <b class="caret"></b>
                </span>
              </a>
            </li>
            <div
              class="collapse m-0"
              id="PartnershipColapse"
              :class="{
                show:
                  routename === 'CorpSalesExcellence' ||
                  routename === 'createCorpSalesExcellence' ||
                  routename === 'editCorpSalesExcellence' ||
                  routename === 'CorpSalesTestimonial' ||
                  routename === 'createCorpSalesTestimonial' ||
                  routename === 'editCorpSalesTestimonial' ||
                  routename === 'bannerCorpSales' ||
                  routename === 'createCorpPartnerList' ||
                  routename === 'editCorpPartnerList' ||
                  routename === 'CorpPartnerList',
              }"
            >
              <router-link
                :to="{ name: 'bannerCorpSales' }"
                :class="{
                  'active border-right-active': routename === 'bannerCorpSales',
                }"
                class="collapse-item"
              >
                <span class="sidebar-normal pl-4">Banner</span>
              </router-link>
              <router-link
                :to="{ name: 'CorpSalesExcellence' }"
                :class="{
                  'active border-right-active':
                    routename === 'CorpSalesExcellence' ||
                    routename === 'createCorpSalesExcellence' ||
                    routename === 'editCorpSalesExcellence',
                }"
                class="collapse-item"
              >
                <span class="sidebar-normal pl-4">Keunggulan</span>
              </router-link>
              <router-link
                :to="{ name: 'CorpSalesTestimonial' }"
                :class="{
                  'active border-right-active':
                    routename === 'createCorpSalesTestimonial' ||
                    routename === 'editCorpSalesTestimonial' ||
                    routename === 'CorpSalesTestimonial',
                }"
                class="collapse-item"
              >
                <span class="sidebar-normal pl-4">Testimonial</span>
              </router-link>
              <router-link
                :to="{ name: 'CorpPartnerList' }"
                :class="{
                  'active border-right-active':
                    routename === 'createCorpPartnerList' ||
                    routename === 'editCorpPartnerList' ||
                    routename === 'CorpPartnerList',
                }"
                class="collapse-item"
              >
                <span class="sidebar-normal pl-4">Daftar Partner</span>
              </router-link>
            </div>
            <router-link
              :to="{ name: 'Privacypolicy' }"
              :class="{
                'active border-right-active':
                  routename === 'Privacypolicy' ||
                  routename === 'editPrivacypolicy' ||
                  routename === 'createPrivacypolicy',
              }"
              class="collapse-item"
              >Kebijakan Privasi</router-link
            >
            <li class="pl-1">
              <a
                class="nav-link collapsed pl-5"
                data-toggle="collapse"
                href="#TncColapse"
                aria-expanded="true"
                aria-controls="TncColapse"
                :class="{
                  'active border-right-active-dropdown':
                    routename === 'TncContent' ||
                    routename === 'createTncContent' ||
                    routename === 'editTncContent' ||
                    routename === 'TncCategory' ||
                    routename === 'createTncCategory' ||
                    routename === 'editTncCategory',
                }"
              >
                <span
                  :class="{
                    'font-weight-normal secondsub-sidebar':
                      routename != 'TncContent' &&
                      routename != 'createTncContent' &&
                      routename != 'editTncContent' &&
                      routename != 'TncCategory' &&
                      routename != 'createTncCategory' &&
                      routename != 'editTncCategory',
                  }"
                  class="sidebar-normal pl-3"
                  >Syarat&Ketentuan</span
                >
              </a>
            </li>
            <div
              class="collapse m-0"
              id="TncColapse"
              :class="{
                show:
                  routename === 'TncContent' ||
                  routename === 'createTncContent' ||
                  routename === 'editTncContent' ||
                  routename === 'TncCategory' ||
                  routename === 'createTncCategory' ||
                  routename === 'editTncCategory',
              }"
            >
              <router-link
                :to="{ name: 'TncCategory' }"
                :class="{
                  'active border-right-active':
                    routename === 'TncCategory' ||
                    routename === 'createTncCategory' ||
                    routename === 'editTncCategory',
                }"
                class="collapse-item"
              >
                <span class="sidebar-normal pl-4">S&K Category</span>
              </router-link>
              <router-link
                :to="{ name: 'TncContent' }"
                :class="{
                  'active border-right-active':
                    routename === 'TncContent' ||
                    routename === 'createTncContent' ||
                    routename === 'editTncContent',
                }"
                class="collapse-item"
              >
                <span class="sidebar-normal pl-4">S&K Content</span>
              </router-link>
            </div>
            <li class="pl-1">
              <a
                class="nav-link collapsed pl-5"
                data-toggle="collapse"
                href="#MicrositeCollapse"
                aria-expanded="true"
                aria-controls="MicrositeCollapse"
                :class="{
                  'active border-right-active-dropdown':
                    routename === 'bannerLocker' ||
                    routename === 'createBannerLocker' ||
                    routename === 'editBannerLocker' ||
                    routename === 'servicesLocker' ||
                    routename === 'createServicesLocker' ||
                    routename === 'editGuestBook' ||
                    routename === 'editServicesLocker',
                }"
              >
                <span
                  :class="{
                    'font-weight-normal secondsub-sidebar':
                      routename != 'bannerLocker' &&
                      routename != 'createBannerLocker' &&
                      routename != 'editBannerLocker' &&
                      routename != 'servicesLocker' &&
                      routename != 'createServicesLocker' &&
                      routename != 'editGuestBook' &&
                      routename != 'editServicesLocker',
                  }"
                  class="sidebar-normal pl-3"
                  >Locker Microsite</span
                >
              </a>
            </li>
            <div
              class="collapse m-0"
              id="MicrositeCollapse"
              :class="{
                show:
                  routename === 'bannerLocker' ||
                  routename === 'createBannerLocker' ||
                  routename === 'editBannerLocker' ||
                  routename === 'servicesLocker' ||
                  routename === 'createServicesLocker' ||
                  routename === 'editGuestBook' ||
                  routename === 'editServicesLocker',
              }"
            >
              <router-link
                :to="{ name: 'bannerLocker' }"
                :class="{
                  'active border-right-active':
                    routename === 'bannerLocker' ||
                    routename === 'createBannerLocker' ||
                    routename === 'editBannerLocker',
                }"
                class="collapse-item"
              >
                <span class="sidebar-normal pl-4">Banner Microsite</span>
              </router-link>
              <router-link
                :to="{ name: 'servicesLocker' }"
                :class="{
                  'active border-right-active':
                    routename === 'servicesLocker' ||
                    routename === 'createServicesLocker' ||
                    routename === 'editServicesLocker',
                }"
                class="collapse-item"
              >
                <span class="sidebar-normal pl-4">PaxelBox Services</span>
              </router-link>
              <router-link
                :to="{ name: 'editGuestBook' }"
                :class="{
                  'active border-right-active': routename === 'editGuestBook',
                }"
                class="collapse-item"
              >
                <span class="sidebar-normal pl-4">Guest Book</span>
              </router-link>
            </div>
            <li class="pl-1">
              <a
                class="nav-link collapsed pl-5"
                data-toggle="collapse"
                href="#DownloadCollapse"
                aria-expanded="true"
                aria-controls="DownloadCollapse"
                :class="{
                  'active border-right-active-dropdown':
                    routename === 'editBannerDownload',
                }"
              >
                <span
                  :class="{
                    'font-weight-normal secondsub-sidebar':
                      routename != 'editBannerDownload',
                  }"
                  class="sidebar-normal pl-3"
                  >Download Page</span
                >
              </a>
            </li>
            <div
              class="collapse m-0"
              id="DownloadCollapse"
              :class="{
                show:
                  routename === 'editBannerDownload',
              }"
            >
              <router-link
                :to="{ name: 'editBannerDownload' }"
                :class="{
                  'active border-right-active':
                    routename === 'editBannerDownload',
                }"
                class="collapse-item"
              >
                <span class="sidebar-normal pl-4">Banner</span>
              </router-link>
            </div>
            <li class="pl-1">
              <a
                class="nav-link collapsed pl-5"
                data-toggle="collapse"
                href="#PejuangOnlineCollapse"
                aria-expanded="true"
                aria-controls="PejuangOnlineCollapse"
                :class="{
                  'active border-right-active-dropdown':
                    routename === 'PejuangOnlineBanner',
                }"
              >
                <span
                  :class="{
                    'font-weight-normal secondsub-sidebar':
                      routename != 'PejuangOnlineBanner',
                  }"
                  class="sidebar-normal pl-3"
                  >Pejuang Online</span
                >
              </a>
            </li>
            <div
              class="collapse m-0"
              id="PejuangOnlineCollapse"
              :class="{
                show:
                  routename === 'PejuangOnlineBanner',
              }"
            >
              <router-link
                :to="{ name: 'PejuangOnlineBanner' }"
                :class="{
                  'active border-right-active': routename === 'PejuangOnlineBanner',
                }"
                class="collapse-item"
              >
                <span class="sidebar-normal pl-4">Banner</span>
              </router-link>
            </div>
            <router-link
              :to="{ name: 'GlobalSearch' }"
              :class="{
                'active border-right-active':
                  routename === 'GlobalSearch' ||
                    routename === 'createGlobalSearch' ||
                    routename === 'editGlobalSearch',
              }"
              class="collapse-item"
              >Global Search</router-link
            >
          </div>

          <!-- <li class="nav-item">
          </li>-->
        </div>
      </li>
      <li
        class="nav-item"
        @mouseover="userapp = true"
        @mouseleave="userapp = false"
        :class="{
          'active border-right-active-dropdown':
            routename === 'GeneralEnableDisableFeature' ||
            routename === 'createGeneralEnableDisableFeature' ||
            routename === 'editGeneralEnableDisableFeature' ||
            routename === 'GeneralContactUs' ||
            routename === 'createGeneralContactUs' ||
            routename === 'editGeneralContactUs' ||
            routename === 'GeneralNewUserPromo' ||
            routename === 'createGeneralNewUserPromo' ||
            routename === 'editGeneralNewUserPromo' ||
            routename === 'GeneralSettings' ||
            routename === 'ReportRefferal' ||
            routename === 'ReportRating' ||
            routename === 'Rate' ||
            routename === 'createRate' ||
            routename === 'editRate' ||
            routename === 'Reason' ||
            routename === 'createReason' ||
            routename === 'editReason' ||
            routename === 'ExtraPackaging' ||
            routename === 'createExtraPackaging' ||
            routename === 'editExtraPackaging' ||
            routename === 'Donasi' ||
            routename === 'createDonasi' ||
            routename === 'editDonasi' ||
            routename === 'ShowCase' ||
            routename === 'createShowCase' ||
            routename === 'editShowCase' ||
            routename === 'newUserPromo' ||
            routename === 'createnewUserPromo' ||
            routename === 'editnewUserPromo' ||
            routename === 'onBoardingScreen' ||
            routename === 'createonBoardingScreen' ||
            routename === 'editonBoardingScreen' ||
            routename === 'Click2buy' ||
            routename === 'formClick2buy' ||
            routename === 'refferalPartner' ||
            routename === 'createrefferalPartner' ||
            routename === 'editrefferalPartner',
        }"
      >
        <a
          class="nav-link collapsed"
          href="#"
          data-toggle="collapse"
          data-target="#collapseUserapp"
          aria-expanded="true"
          aria-controls="collapseUserapp"
        >
          <img
            src="@/assets/ic-phone-mobile.svg"
            alt
            class="px-2"
            v-if="
              userapp ||
              routename === 'GeneralEnableDisableFeature' ||
              routename === 'createGeneralEnableDisableFeature' ||
              routename === 'editGeneralEnableDisableFeature' ||
              routename === 'GeneralContactUs' ||
              routename === 'createGeneralContactUs' ||
              routename === 'editGeneralContactUs' ||
              routename === 'GeneralNewUserPromo' ||
              routename === 'createGeneralNewUserPromo' ||
              routename === 'editGeneralNewUserPromo' ||
              routename === 'GeneralSettings' ||
              routename === 'ReportRefferal' ||
              routename === 'ReportRating' ||
              routename === 'Rate' ||
              routename === 'createRate' ||
              routename === 'editRate' ||
              routename === 'Reason' ||
              routename === 'createReason' ||
              routename === 'editReason' ||
              routename === 'ExtraPackaging' ||
              routename === 'createExtraPackaging' ||
              routename === 'editExtraPackaging' ||
              routename === 'Donasi' ||
              routename === 'createDonasi' ||
              routename === 'editDonasi' ||
              routename === 'ShowCase' ||
              routename === 'createShowCase' ||
              routename === 'editShowCase' ||
              routename === 'newUserPromo' ||
              routename === 'createnewUserPromo' ||
              routename === 'editnewUserPromo' ||
              routename === 'onBoardingScreen' ||
              routename === 'createonBoardingScreen' ||
              routename === 'editonBoardingScreen' ||
              routename === 'Click2buy' ||
              routename === 'formClick2buy' ||
              routename === 'refferalPartner' ||
              routename === 'createrefferalPartner' ||
              routename === 'editrefferalPartner'
            "
          />
          <img
            src="@/assets/ic-phone-mobile-inactive.svg"
            alt
            class="px-2"
            v-else-if="
              routename != 'GeneralEnableDisableFeature' &&
              routename != 'createGeneralEnableDisableFeature' &&
              routename != 'editGeneralEnableDisableFeature' &&
              routename != 'GeneralContactUs' &&
              routename != 'createGeneralContactUs' &&
              routename != 'editGeneralContactUs' &&
              routename != 'GeneralNewUserPromo' &&
              routename != 'createGeneralNewUserPromo' &&
              routename != 'editGeneralNewUserPromo' &&
              routename != 'GeneralSettings' &&
              routename != 'ReportRefferal' &&
              routename != 'ReportRating' &&
              routename != 'Rate' &&
              routename != 'createRate' &&
              routename != 'editRate' &&
              routename != 'Reason' &&
              routename != 'createReason' &&
              routename != 'editReason' &&
              routename != 'ExtraPackaging' &&
              routename != 'createExtraPackaging' &&
              routename != 'editExtraPackaging' &&
              routename != 'Donasi' &&
              routename != 'createDonasi' &&
              routename != 'editDonasi' &&
              routename != 'newUserPromo' &&
              routename != 'ShowCase' &&
              routename != 'createShowCase' &&
              routename != 'editShowCase' &&
              routename != 'createnewUserPromo' &&
              routename != 'editnewUserPromo' &&
              routename != 'onBoardingScreen' &&
              routename != 'createonBoardingScreen' &&
              routename != 'editonBoardingScreen' &&
              routename != 'Click2buy' &&
              routename != 'formClick2buy' &&
              routename != 'refferalPartner' &&
              routename != 'createrefferalPartner' &&
              routename != 'editrefferalPartner' &&
              !userapp
            "
          />
          <span>User App Setting</span>
        </a>
        <div
          id="collapseUserapp"
          class="collapse"
          aria-labelledby="headingPages"
          data-parent="#accordionSidebar"
          :class="{
            show:
              routename === 'GeneralEnableDisableFeature' ||
              routename === 'createGeneralEnableDisableFeature' ||
              routename === 'editGeneralEnableDisableFeature' ||
              routename === 'GeneralContactUs' ||
              routename === 'createGeneralContactUs' ||
              routename === 'editGeneralContactUs' ||
              routename === 'GeneralNewUserPromo' ||
              routename === 'createGeneralNewUserPromo' ||
              routename === 'editGeneralNewUserPromo' ||
              routename === 'GeneralSettings' ||
              routename === 'ReportRefferal' ||
              routename === 'ReportRating' ||
              routename === 'Rate' ||
              routename === 'createRate' ||
              routename === 'editRate' ||
              routename === 'Reason' ||
              routename === 'createReason' ||
              routename === 'editReason' ||
              routename === 'ExtraPackaging' ||
              routename === 'createExtraPackaging' ||
              routename === 'editExtraPackaging' ||
              routename === 'Donasi' ||
              routename === 'createDonasi' ||
              routename === 'editDonasi' ||
              routename === 'ShowCase' ||
              routename === 'createShowCase' ||
              routename === 'editShowCase' ||
              routename === 'newUserPromo' ||
              routename === 'createnewUserPromo' ||
              routename === 'editnewUserPromo' ||
              routename === 'onBoardingScreen' ||
              routename === 'createonBoardingScreen' ||
              routename === 'editonBoardingScreen' ||
              routename === 'Click2buy' ||
              routename === 'formClick2buy' ||
              routename === 'refferalPartner' ||
              routename === 'createrefferalPartner' ||
              routename === 'editrefferalPartner',
          }"
        >
          <div class="bg-white collapse-inner text-left">
            <!-- <router-link
              :to="{name: 'newUserPromo'}"
              :class="{ 'active border-right-active': routename === 'newUserPromo' || routename === 'createnewUserPromo'|| routename === 'editnewUserPromo' }"
              class="collapse-item"
            >New User Promo</router-link>-->
            <!-- <router-link
              :to="{name: 'ShowCase'}"
              :class="{ 'active border-right-active': routename === 'ShowCase' || routename === 'createShowCase'|| routename === 'editShowCase' }"
              class="collapse-item"
            >Show Case</router-link>-->
            <router-link
              :to="{ name: 'Donasi' }"
              :class="{
                'active border-right-active':
                  routename === 'Donasi' ||
                  routename === 'createDonasi' ||
                  routename === 'editDonasi',
              }"
              class="collapse-item"
              >Donasi</router-link
            >
            <!-- <router-link
              :to="{name: 'ExtraPackaging'}"
              :class="{ 'active border-right-active': routename === 'ExtraPackaging' || routename === 'createExtraPackaging'|| routename === 'editExtraPackaging' }"
              class="collapse-item"
            >Extra Packaging</router-link>-->
            <li class="pl-1">
              <a
                class="nav-link collapsed pl-5"
                data-toggle="collapse"
                href="#RateColapse"
                aria-expanded="true"
                aria-controls="RateColapse"
                :class="{
                  'active border-right-active-dropdown':
                    routename === 'Rate' ||
                    routename === 'Reason' ||
                    routename === 'ReportRating' ||
                    routename === 'createRate' ||
                    routename === 'editRate',
                }"
              >
                <span
                  :class="{
                    'font-weight-normal secondsub-sidebar':
                      routename != 'Rate' &&
                      routename != 'Reason' &&
                      routename != 'ReportRating' &&
                      routename != 'createRate' &&
                      routename != 'editRate',
                  }"
                  class="sidebar-normal pl-3"
                >
                  Rating &nbsp;
                  <b class="caret"></b>
                </span>
              </a>
            </li>
            <div
              class="collapse m-0"
              id="RateColapse"
              :class="{
                show:
                  routename === 'Rate' ||
                  routename === 'Reason' ||
                  routename === 'createRate' ||
                  routename === 'editRate' ||
                  routename === 'createReason' ||
                  routename === 'editReason' ||
                  routename === 'ReportRating',
              }"
            >
              <router-link
                :to="{ name: 'Rate' }"
                :class="{
                  'active border-right-active':
                    routename === 'Rate' ||
                    routename === 'createRate' ||
                    routename === 'editRate',
                }"
                class="collapse-item"
              >
                <span class="sidebar-normal pl-4">Rate</span>
              </router-link>
              <router-link
                :to="{ name: 'Reason' }"
                :class="{
                  'active border-right-active':
                    routename === 'Reason' ||
                    routename === 'createReason' ||
                    routename === 'editReason',
                }"
                class="collapse-item"
              >
                <span class="sidebar-normal pl-4">Reason</span>
              </router-link>
              <router-link
                :to="{ name: 'ReportRating' }"
                :class="{
                  'active border-right-active': routename === 'ReportRating',
                }"
                class="collapse-item"
              >
                <span class="sidebar-normal pl-4">Report</span>
              </router-link>
            </div>
            <router-link
              :to="{ name: 'Click2buy' }"
              :class="{
                'active border-right-active':
                  routename === 'Click2buy' ||
                  routename === 'formClick2buy',
              }"
              class="collapse-item"
              >Click2Buy</router-link
            >
            <router-link
              :to="{ name: 'onBoardingScreen' }"
              :class="{
                'active border-right-active':
                  routename === 'onBoardingScreen' ||
                  routename === 'createonBoardingScreen' ||
                  routename === 'editonBoardingScreen',
              }"
              class="collapse-item"
              >On Boarding Screen</router-link
            >
            <li class="pl-1">
              <a
                class="nav-link collapsed pl-5"
                data-toggle="collapse"
                href="#RefferalColapse"
                aria-expanded="true"
                aria-controls="RefferalColapse"
                :class="{
                  'active border-right-active-dropdown':
                    routename === 'refferalPartner' ||
                    routename === 'ReportRefferal' ||
                    routename === 'createrefferalPartner' ||
                    routename === 'editrefferalPartner',
                }"
              >
                <span
                  :class="{
                    'font-weight-normal secondsub-sidebar':
                      routename != 'refferalPartner' &&
                      routename != 'ReportRefferal' &&
                      routename != 'createrefferalPartner' &&
                      routename != 'editrefferalPartner',
                  }"
                  class="sidebar-normal pl-3"
                >
                  Refferal &nbsp;
                  <b class="caret"></b>
                </span>
              </a>
            </li>
            <div
              class="collapse m-0"
              id="RefferalColapse"
              :class="{
                show:
                  routename === 'refferalPartner' ||
                  routename === 'ReportRefferal' ||
                  routename === 'createrefferalPartner' ||
                  routename === 'editrefferalPartner',
              }"
            >
              <router-link
                :to="{ name: 'refferalPartner' }"
                :class="{
                  'active border-right-active':
                    routename === 'refferalPartner' ||
                    routename === 'createrefferalPartner' ||
                    routename === 'editrefferalPartner',
                }"
                class="collapse-item"
              >
                <span class="sidebar-normal pl-4">Partner</span>
              </router-link>
              <router-link
                :to="{ name: 'ReportRefferal' }"
                :class="{
                  'active border-right-active': routename === 'ReportRefferal',
                }"
                class="collapse-item"
              >
                <span class="sidebar-normal pl-4">Report</span>
              </router-link>
            </div>
            <li class="pl-1">
              <a
                class="nav-link collapsed pl-5"
                data-toggle="collapse"
                href="#GeneralSettingsColapse"
                aria-expanded="true"
                aria-controls="GeneralSettingsColapse"
                :class="{
                  'active border-right-active-dropdown':
                    routename === 'GeneralEnableDisableFeature' ||
                    routename === 'createGeneralEnableDisableFeature' ||
                    routename === 'editGeneralEnableDisableFeature' ||
                    routename === 'GeneralContactUs' ||
                    routename === 'GeneralNewUserPromo' ||
                    routename === 'createGeneralContactUs' ||
                    routename === 'editGeneralContactUs' ||
                    routename === 'createGeneralNewUserPromo' ||
                    routename === 'editGeneralNewUserPromo',
                }"
              >
                <span
                  :class="{
                    'font-weight-normal secondsub-sidebar':
                      routename != 'GeneralEnableDisableFeature' &&
                      routename != 'createGeneralEnableDisableFeature' &&
                      routename != 'editGeneralEnableDisableFeature' &&
                      routename != 'GeneralContactUs' &&
                      routename != 'GeneralNewUserPromo' &&
                      routename != 'createGeneralContactUs' &&
                      routename != 'editGeneralContactUs' &&
                      routename != 'createGeneralNewUserPromo' &&
                      routename != 'editGeneralNewUserPromo',
                  }"
                  class="sidebar-normal pl-3"
                >
                  General Settings &nbsp;
                  <b class="caret"></b>
                </span>
              </a>
            </li>
            <div
              class="collapse m-0"
              id="GeneralSettingsColapse"
              :class="{
                show:
                  routename === 'GeneralEnableDisableFeature' ||
                  routename === 'createGeneralEnableDisableFeature' ||
                  routename === 'editGeneralEnableDisableFeature' ||
                  routename === 'GeneralContactUs' ||
                  routename === 'createGeneralContactUs' ||
                  routename === 'editGeneralContactUs' ||
                  routename === 'GeneralNewUserPromo' ||
                  routename === 'createGeneralNewUserPromo' ||
                  routename === 'editGeneralNewUserPromo',
              }"
            >
              <router-link
                :to="{ name: 'GeneralContactUs' }"
                :class="{
                  'active border-right-active':
                    routename === 'GeneralContactUs' ||
                    routename === 'createGeneralContactUs' ||
                    routename === 'editGeneralContactUs',
                }"
                class="collapse-item"
              >
                <span class="sidebar-normal pl-4">Contact Us</span>
              </router-link>
              <router-link
                :to="{ name: 'GeneralEnableDisableFeature' }"
                :class="{
                  'active border-right-active':
                    routename === 'GeneralEnableDisableFeature' ||
                    routename === 'createGeneralEnableDisableFeature' ||
                    routename === 'editGeneralEnableDisableFeature',
                }"
                class="collapse-item"
              >
                <span class="sidebar-normal pl-4">Feature ON/OFF</span>
              </router-link>
              <router-link
                :to="{ name: 'GeneralNewUserPromo' }"
                :class="{
                  'active border-right-active':
                    routename === 'createGeneralNewUserPromo' ||
                    routename === 'editGeneralNewUserPromo' ||
                    routename === 'GeneralNewUserPromo',
                }"
                class="collapse-item"
              >
                <span class="sidebar-normal pl-4">New User Promo</span>
              </router-link>
            </div>
          </div>
        </div>
      </li>
      <li
        class="nav-item"
        @mouseover="paxelin_club = true"
        @mouseleave="paxelin_club = false"
        :class="{
          'active border-right-active-dropdown':
            routename === 'Members' ||
            routename === 'Event' ||
            routename === 'createEvent' ||
            routename === 'editEvent'||
            routename === 'PointSales' ||
            routename === 'createPointSales' ||
            routename === 'editPointSales'||
            routename === 'VoucerService' ||
            routename === 'createVoucerService' ||
            routename === 'editVoucerService'||
            routename === 'ClaimedBenefit'||
            routename === 'createClaimedBenefit'||
            routename === 'editClaimedBenefit'||
            routename === 'BenefitCategory'||
            routename === 'createBenefitCategory'||
            routename === 'editBenefitCategory'||
            routename === 'BenefitType'||
            routename === 'createBenefitType'||
            routename === 'editBenefitType'||
            routename === 'Benefit'||
            routename === 'createBenefit'||
            routename === 'editBenefit',
        }"
      >
        <a
          class="nav-link collapsed"
          href="#"
          data-toggle="collapse"
          data-target="#collapsePaxelinClub"
          aria-expanded="true"
          aria-controls="collapsePaxelinClub"
        >
          <img
            src="@/assets/ic-favorite.svg"
            alt
            class="px-2"
            v-if="
              paxelin_club ||
              routename === 'Members' ||
              routename === 'Event' ||
              routename === 'createEvent' ||
              routename === 'editEvent'||
              routename === 'PointSales' ||
              routename === 'createPointSales' ||
              routename === 'editPointSales'||
              routename === 'VoucerService' ||
              routename === 'createVoucerService' ||
              routename === 'editVoucerService'||
              routename === 'ClaimedBenefit'||
              routename === 'createClaimedBenefit'||
              routename === 'editClaimedBenefit'||
              routename === 'BenefitCategory'||
              routename === 'createBenefitCategory'||
              routename === 'editBenefitCategory'||
              routename === 'BenefitType'||
              routename === 'createBenefitType'||
              routename === 'editBenefitType'||
              routename === 'Benefit'||
              routename === 'createBenefit'||
              routename === 'editBenefit'
            "
          />
          <img
            src="@/assets/ic-favorite-bw.svg"
            alt
            class="px-2"
            v-else-if="
              routename != 'Members' &&
              routename != 'Event' &&
              routename != 'createEvent' &&
              routename != 'editEvent' &&
              routename != 'PointSales' &&
              routename != 'createPointSales' &&
              routename != 'editPointSales' &&
              routename != 'VoucerService' &&
              routename != 'createVoucerService' &&
              routename != 'editVoucerService' &&
              routename != 'ClaimedBenefit' &&
              routename != 'createClaimedBenefit' &&
              routename != 'editClaimedBenefit' &&
              routename != 'BenefitCategory' &&
              routename != 'createBenefitCategory' &&
              routename != 'editBenefitCategory' &&
              routename != 'BenefitType' &&
              routename != 'createBenefitType' &&
              routename != 'editBenefitType' &&
              routename != 'Benefit' &&
              routename != 'createBenefit' &&
              routename != 'editBenefit' &&
              !paxelin_club
            "
          />
          <span>Paxelin Club</span>
        </a>
        <div
          id="collapsePaxelinClub"
          class="collapse"
          aria-labelledby="headingPages"
          data-parent="#accordionSidebar"
          :class="{
            show:
              routename === 'Members' ||
              routename === 'Event' ||
              routename === 'createEvent' ||
              routename === 'editEvent'||
              routename === 'PointSales' ||
              routename === 'createPointSales' ||
              routename === 'editPointSales'||
              routename === 'VoucerService' ||
              routename === 'createVoucerService' ||
              routename === 'editVoucerService'||
              routename === 'ClaimedBenefit'||
              routename === 'createClaimedBenefit'||
              routename === 'editClaimedBenefit' ||
              routename === 'BenefitCategory'||
              routename === 'createBenefitCategory'||
              routename === 'editBenefitCategory'||
              routename === 'BenefitType'||
              routename === 'createBenefitType'||
              routename === 'editBenefitType'||
              routename === 'Benefit'||
              routename === 'createBenefit'||
              routename === 'editBenefit',
          }"
        >
          <div class="bg-white collapse-inner text-left">
            <router-link
              :to="{ name: 'Members' }"
              :class="{
                'active border-right-active':
                  routename === 'Members',
              }"
              class="collapse-item"
              >Members</router-link
            >
            <router-link
              :to="{ name: 'BenefitCategory' }"
              :class="{
                'active border-right-active':
                  routename === 'BenefitCategory' ||
                  routename === 'createBenefitCategory' ||
                  routename === 'editBenefitCategory',
              }"
              class="collapse-item"
              >Master Benefit Category</router-link
            >
            <router-link
              :to="{ name: 'BenefitType' }"
              :class="{
                'active border-right-active':
                  routename === 'BenefitType' ||
                  routename === 'createBenefitType' ||
                  routename === 'editBenefitType',
              }"
              class="collapse-item"
              >Master Benefit Type</router-link
            >
            <router-link
              :to="{ name: 'Benefit' }"
              :class="{
                'active border-right-active':
                  routename === 'Benefit' ||
                  routename === 'createBenefit' ||
                  routename === 'editBenefit',
              }"
              class="collapse-item"
              >Benefit</router-link
            >
            <!-- <router-link
              :to="{ name: 'Event' }"
              :class="{
                'active border-right-active':
                  routename === 'Event' ||
                  routename === 'createEvent' ||
                  routename === 'editEvent',
              }"
              class="collapse-item"
              >Upcoming Event</router-link
            >
            <router-link
              :to="{ name: 'PointSales' }"
              :class="{
                'active border-right-active':
                  routename === 'PointSales' ||
                  routename === 'createPointSales' ||
                  routename === 'editPointSales',
              }"
              class="collapse-item"
              >Tools</router-link
            > -->
            <!-- <router-link
              :to="{ name: 'VoucerService' }"
              :class="{
                'active border-right-active':
                  routename === 'VoucerService' ||
                  routename === 'createVoucerService' ||
                  routename === 'editVoucerService',
              }"
              class="collapse-item"
              >Voucher. Service and License</router-link
            > -->
            <router-link
              :to="{ name: 'ClaimedBenefit' }"
              :class="{
                'active border-right-active':
                  routename === 'ClaimedBenefit' ||
                  routename === 'createClaimedBenefit' ||
                  routename === 'editClaimedBenefit',
              }"
              class="collapse-item"
              >Claimed Benefit</router-link
            >
          </div>
        </div>
      </li>
    </div>

    <div
      v-show="
        session.role == 'developer' ||
        session.role == 'superadmin'
      "
    >
      <hr class="sidebar-divider" />
      <div class="sidebar-heading">Developer</div>
      <li
        @mouseover="developer_error_log = true"
        @mouseleave="developer_error_log = false"
        class="nav-item text-nowrap"
        :class="{
          'active border-right-active':
            routename === 'ErrorLog',
        }"
      >
        <router-link :to="{ name: 'ErrorLog' }" class="nav-link">
          <img
            src="@/assets/ic-manage-account_color.svg"
            alt
            class="px-2"
            v-if="
              developer_error_log ||
              routename === 'ErrorLog'
            "
          />
          <img
            src="@/assets/ic-manage-account_bw.svg"
            alt
            class="px-2"
            v-else-if="
              routename != 'ErrorLog' &&
              !developer_error_log
            "
          />
          <span>Shipment Log</span>
        </router-link>
      </li>
      <li
        v-show="
          session.role == 'developer' ||
          session.role == 'superadmin'
        "
        @mouseover="developer_guide_book = true"
        @mouseleave="developer_guide_book = false"
        class="nav-item"
        :class="{
          'active border-right-active':
            routename === 'GuideBook' ||
            routename === 'createGuideBook' ||
            routename === 'editGuideBook'
        }"
      >
        <router-link :to="{ name: 'GuideBook' }" class="nav-link">
          <img
            src="@/assets/ic-manage-account_color.svg"
            alt
            class="px-2"
            v-if="
              developer_guide_book ||
              routename === 'GuideBook' ||
              routename === 'createGuideBook' ||
              routename === 'editGuideBook'
            "
          />
          <img
            src="@/assets/ic-manage-account_bw.svg"
            alt
            class="px-2"
            v-else-if="
              routename != 'GuideBook' &&
              routename != 'createGuideBook' &&
              routename != 'editGuideBook' &&
              !developer_guide_book
            "
          />
          <span>Error Guide Book</span>
        </router-link>
      </li>
    </div>

    <!-- Divider -->

    <!-- Heading -->
    <!-- <div v-show="session.role == 'px' || session.role == 'superadmin'">
      <hr class="sidebar-divider" />
      <div class="sidebar-heading">PX</div>
      <li
        class="nav-item"
        @mouseover="career = true"
        @mouseleave="career = false"
        :class="{ 'active border-right-active-dropdown': routename === 'pxBenefits' || routename === 'pxJobVacancy' ||routename === 'createJobVacancy'||routename === 'editJobVacancy' || routename === 'pxLifeInPaxel'|| routename === 'createLifeInPaxel'|| routename === 'editLifeInPaxel' || routename === 'pxOnlineTest'|| routename === 'createOnlineTest'|| routename === 'editOnlineTest' || routename === 'pxTestimonial'|| routename === 'createBenefits'|| routename === 'editBenefits' || routename == 'createTestimonial'|| routename == 'editTestimonial' }"
      >
        <a
          class="nav-link collapsed"
          href="#"
          data-toggle="collapse"
          data-target="#collapseCareer"
          aria-expanded="true"
          aria-controls="collapseCareer"
        >
          <img
            src="@/assets/ic-manage-account_color.svg"
            alt
            class="px-2"
            v-if="career || routename === 'pxBenefits' || routename === 'createBenefits'|| routename === 'editBenefits' || routename === 'pxJobVacancy'||routename === 'createJobVacancy'||routename === 'editJobVacancy' || routename === 'pxLifeInPaxel' || routename === 'createLifeInPaxel'|| routename === 'editLifeInPaxel' || routename === 'pxOnlineTest'|| routename === 'createOnlineTest'|| routename === 'editOnlineTest' || routename === 'pxTestimonial' || routename === 'createTestimonial'|| routename === 'editTestimonial'"
          />
          <img
            src="@/assets/ic-manage-account_bw.svg"
            alt
            class="px-2"
            v-else-if="routename != 'pxBenefits' && routename != 'createBenefits'&& routename != 'editBenefits' && routename != 'pxJobVacancy' && routename != 'createJobVacancy'&& routename != 'editJobVacancy' && routename != 'pxLifeInPaxel' && routename != 'createLifeInPaxel'&& routename != 'editLifeInPaxel' && routename != 'pxOnlineTest' && routename != 'createOnlineTest'&& routename != 'editOnlineTest' && routename != 'pxTestimonial' && routename != 'createTestimonial'&& routename != 'editTestimonial' && !career"
          />
          <span>Career</span>
        </a>
        <div
          id="collapseCareer"
          class="collapse"
          :class="{ 'show': routename === 'pxBenefits' || routename === 'createBenefits'|| routename === 'editBenefits' || routename === 'pxJobVacancy'||routename === 'createJobVacancy'||routename === 'editJobVacancy' || routename === 'pxLifeInPaxel' || routename === 'createLifeInPaxel'|| routename === 'editLifeInPaxel' || routename === 'pxOnlineTest'|| routename === 'createOnlineTest'|| routename === 'editOnlineTest' || routename === 'pxTestimonial' || routename === 'createTestimonial'|| routename === 'editTestimonial' }"
          aria-labelledby="headingPages"
          data-parent="#accordionSidebar"
        >
          <div class="bg-white collapse-inner text-left">
            <router-link
              :to="{name: 'pxBenefits'}"
              :class="{ 'active border-right-active': routename === 'pxBenefits' || routename === 'createBenefits'|| routename === 'editBenefits' }"
              class="collapse-item"
            >Benefits</router-link>
            <router-link
              :to="{name: 'pxJobVacancy'}"
              :class="{ 'active border-right-active': routename === 'pxJobVacancy' ||routename === 'createJobVacancy'||routename === 'editJobVacancy' }"
              class="collapse-item"
            >Job Vacancy</router-link>
            <router-link
              :to="{name: 'pxLifeInPaxel'}"
              :class="{ 'active border-right-active': routename === 'pxLifeInPaxel' || routename === 'createLifeInPaxel'|| routename === 'editLifeInPaxel' }"
              class="collapse-item"
            >Life in Paxel</router-link>
            <router-link
              :to="{name: 'pxOnlineTest'}"
              :class="{ 'active border-right-active': routename === 'pxOnlineTest' || routename === 'createOnlineTest'|| routename === 'editOnlineTest' }"
              class="collapse-item"
            >Online Test</router-link>
            <router-link
              :to="{name: 'pxTestimonial'}"
              :class="{ 'active border-right-active': routename === 'pxTestimonial' || routename === 'createTestimonial'|| routename === 'editTestimonial' }"
              class="collapse-item"
            >Testimonial</router-link>
          </div>
        </div>
      </li>
      <li
        class="nav-item"
        @mouseover="hero = true"
        @mouseleave="hero = false"
        :class="{ 'active border-right-active-dropdown': routename === 'pxHero' || routename === 'detailCandidateHero' || routename === 'pxHeroDasboard'|| routename === 'pxHeroHired' }"
      >
        <a
          class="nav-link collapsed"
          href="#"
          data-toggle="collapse"
          data-target="#collapseHero"
          aria-expanded="true"
          aria-controls="collapseHero"
        >
          <img
            src="@/assets/ic-manage-account_color.svg"
            alt
            class="px-2"
            v-if="hero || routename === 'pxHero'|| routename === 'detailCandidateHero' || routename === 'pxHeroDasboard'|| routename === 'pxHeroHired'"
          />
          <img
            src="@/assets/ic-manage-account_bw.svg"
            alt
            class="px-2"
            v-else-if="routename != 'pxHero' && routename != 'detailCandidateHero' && routename != 'pxHeroDasboard' && routename != 'pxHeroHired' && !hero"
          />
          <span>Happiness Hero</span>
        </a>
        <div
          id="collapseHero"
          class="collapse"
          aria-labelledby="headingPages"
          data-parent="#accordionSidebar"
          :class="{ 'show': routename === 'pxHero' || routename === 'detailCandidateHero' || routename === 'pxHeroDasboard'|| routename === 'pxHeroHired' }"
        >
          <div class="bg-white collapse-inner text-left">
            <router-link
              :to="{name: 'pxHeroDasboard'}"
              :class="{ 'active border-right-active': routename === 'pxHeroDasboard' }"
              class="collapse-item"
            >Hero Dashboard</router-link>
            <router-link
              :to="{name: 'pxHero'}"
              :class="{ 'active border-right-active': routename === 'pxHero' || routename === 'detailCandidateHero' }"
              class="collapse-item"
            >Hero Candidates</router-link>
            <router-link
              :to="{name: 'pxHeroHired'}"
              :class="{ 'active border-right-active': routename === 'pxHeroHired' }"
              class="collapse-item"
            >Hired Heroes</router-link>
          </div>
        </div>
      </li>
      <li
        class="nav-item"
        @mouseover="paxelian = true"
        @mouseleave="paxelian = false"
        :class="{ 'active border-right-active-dropdown': routename === 'pxReport' || routename === 'detailCandidate' ||  routename === 'pxDashboard'|| routename === 'pxHired' }"
      >
        <a
          class="nav-link collapsed"
          href="#"
          data-toggle="collapse"
          data-target="#collapsePaxelian"
          aria-expanded="true"
          aria-controls="collapsePaxelian"
        >
          <img
            src="@/assets/ic-manage-account_color.svg"
            alt
            class="px-2"
            v-if="paxelian || routename === 'pxReport' || routename === 'detailCandidate' ||  routename === 'pxDashboard'|| routename === 'pxHired'"
          />
          <img
            src="@/assets/ic-manage-account_bw.svg"
            alt
            class="px-2"
            v-else-if="routename != 'pxReport' && routename != 'detailCandidate' && routename != 'pxDashboard' && routename != 'pxHired' && !paxelian"
          />
          <span>Paxelian</span>
        </a>
        <div
          id="collapsePaxelian"
          class="collapse"
          aria-labelledby="headingPages"
          data-parent="#accordionSidebar"
          :class="{ 'show': routename === 'pxReport' || routename === 'detailCandidate' ||  routename === 'pxDashboard'|| routename === 'pxHired' }"
        >
          <div class="bg-white collapse-inner text-left">
            <router-link
              :to="{name: 'pxDashboard'}"
              :class="{ 'active border-right-active': routename === 'pxDashboard' }"
              class="collapse-item"
            >Paxelian Dashboard</router-link>
            <router-link
              :to="{name: 'pxReport'}"
              :class="{ 'active border-right-active': routename === 'pxReport' || routename === 'detailCandidate' }"
              class="collapse-item"
            >Paxelian Candidates</router-link>
            <router-link
              :to="{name: 'pxHired'}"
              :class="{ 'active border-right-active': routename === 'pxHired' }"
              class="collapse-item"
            >Hired Paxelian</router-link>
          </div>
        </div>
      </li>
      <li
        class="nav-item"
        @mouseover="program_baru = true"
        @mouseleave="program_baru = false"
        :class="{ 'active border-right-active-dropdown': routename === 'BaruDashboard' || routename === 'BaruManageAccount' || routename === 'BaruManageMember'|| routename === 'detailBaruMember' }"
      >
        <a
          class="nav-link collapsed"
          href="#"
          data-toggle="collapse"
          data-target="#collapseBaru"
          aria-expanded="true"
          aria-controls="collapseBaru"
        >
          <img
            src="@/assets/ic-manage-account_color.svg"
            alt
            class="px-2"
            v-if="program_baru || routename === 'BaruDashboard' || routename === 'BaruManageAccount' || routename === 'BaruManageMember'|| routename === 'detailBaruMember'"
          />
          <img
            src="@/assets/ic-manage-account_bw.svg"
            alt
            class="px-2"
            v-else-if="routename != 'BaruDashboard' && routename != 'BaruManageAccount' && routename != 'BaruManageMember' && routename != 'detailBaruMember' && !program_baru"
          />
          <span>Program Baru</span>
        </a>
        <div
          id="collapseBaru"
          class="collapse"
          aria-labelledby="headingPages"
          data-parent="#accordionSidebar"
          :class="{ 'show': routename === 'BaruDashboard' || routename === 'BaruManageAccount' || routename === 'BaruManageMember'|| routename === 'detailBaruMember' }"
        >
          <div class="bg-white collapse-inner text-left">
            <router-link
              :to="{name: 'BaruDashboard'}"
              :class="{ 'active border-right-active': routename === 'BaruDashboard' }"
              class="collapse-item"
            >Dashboard</router-link>
            <router-link
              :to="{name: 'BaruManageAccount'}"
              :class="{ 'active border-right-active': routename === 'BaruManageAccount'  }"
              class="collapse-item"
            >Manage Account</router-link>
            <router-link
              :to="{name: 'BaruManageMember'}"
              :class="{ 'active border-right-active': routename === 'BaruManageMember' || routename === 'detailBaruMember' }"
              class="collapse-item"
            >Manage Member</router-link>
          </div>
        </div>
      </li>
    </div>-->

    <!-- Heading -->

    <!-- Nav Item - Pages Collapse Menu -->

    <!-- Nav Item - Pages Collapse Menu -->

    <!-- Nav Item - Tables -->

    <!-- Divider -->
    <hr class="sidebar-divider d-none d-md-block" />

    <!-- Sidebar Toggler (Sidebar) -->
    <div class="text-center d-none d-md-inline">
      <!-- <button class="rounded-circle border-0" id="sidebarToggle"></button> -->
    </div>
    {{
      changeRoute()
    }}
  </ul>
</template>

<script>
export default {
  data() {
    return {
      routename: null,
      program_baru: false,
      finance: false,
      cx: false,
      cxAutoClaim: false,
      cxFoodClaim: false,
      cxInstantClaim: false,
      cxCorporateClaim: false,
      article: false,
      paxelin_club: false,
      dashboard: false,
      dashboard_finance: false,
      paxelco: false,
      career: false,
      paxel_market: false,
      paxelian: false,
      hero: false,
      userapp: false,
      internal_user: false,
      transaction_log: false,
      payment_instruction: false,
      message_service: false,
      message_settings: false,
      shortener_service: false,
      ppob: false,
      promo_voucher_setting: false,
      claim_setting: false,
      claim_excess: false,
      developer_error_log: false,
      developer_guide_book: false,
      session: this.$session.get("jwt"),
    };
  },
  methods: {
    changeRoute() {
      this.routename = this.$route.name;
    },
  },
  computed: {
    button() {},
  },
  mounted() {},
  created() {},
};
</script>

<style>
@font-face {
  font-family: "Netto";
  src: url("../../../assets/netto.ttf");
}
@font-face {
  font-family: "Gotham";
  src: url("../../../assets/Gotham.ttf");
}
.secondsub-sidebar {
  color: #999;
}
</style>
